// array is printed in reverse order; later("newer") elements are printed first
// Note to self: insert new decor at end of array, in right-to-left order of in-game for each theme
const decorArray = [
    /* Start of Crispy Cookie Town */
    {
        name: "Lawn",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct1.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Soda Stream",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 0,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct2.png',
        note: "",
        color: ["blue", "green"],
    },
    {
        name: "Village Lane",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct3.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Cracker Flowerbed",
        theme: "Crispy Cookie Town",
        size: "2x2",
        points: 10,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct4.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Choco Stick Streetlight",
        theme: "Crispy Cookie Town",
        size: "2x2",
        points: 10,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Candy Standpipe",
        theme: "Crispy Cookie Town",
        size: "2x2",
        points: 10,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct6.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Choco Stick Drying Rack",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 15,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Pretzel Fence",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 15,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct8.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Roll Cake Flowerbed",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 15,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct9.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Choco Gazebo",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 15,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct10.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Roll Cake Garden Table",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 15,
        tags: ["Table", "Cookie Interaction", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct11.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Berry Churros Swing",
        theme: "Crispy Cookie Town",
        size: "4x4",
        points: 15,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct12.png',
        note: "Cookie Decor for Strawberry Cookie or Gingerbrave Cookie",
        color: ["brown", "pink"],
    },
    {
        name: "Tick Tock Clock Tower",
        theme: "Crispy Cookie Town",
        size: "16x16",
        points: 170,
        tags: ["Landmark", "Tower"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cct/cct13.png',
        note: "",
        color: ["brown", "green"],
    },
    /* Start of Camping Time */
    {
        name: "Roll Cake Pot Hanger",
        theme: "Camping Time",
        size: "2x2",
        points: 11,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Sweet Stick Firewood",
        theme: "Camping Time",
        size: "2x2",
        points: 11,
        tags: ["Fire"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Basket of Berries",
        theme: "Camping Time",
        size: "2x2",
        points: 11,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct3.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Comfy Candy Stool",
        theme: "Camping Time",
        size: "2x2",
        points: 11,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct4.png',
        note: "",
        color: ["red", "white"],
    },
    {
        name: "Jellybelt Hammock",
        theme: "Camping Time",
        size: "4x4",
        points: 16,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Pancake Tent",
        theme: "Camping Time",
        size: "4x4",
        points: 16,
        tags: ["Tent"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct6.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Jellysteak BBQ",
        theme: "Camping Time",
        size: "4x4",
        points: 16,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct7.png',
        note: "",
        color: ["red", "brown"],
    },
    {
        name: "Long-lasting Campfire",
        theme: "Camping Time",
        size: "4x4",
        points: 16,
        tags: ["Fire", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ct/ct8.png',
        note: "",
        color: ["orange", "brown"],
    },
    /*Start of Land of Peace & Healing*/
    {
        name: "Magic Primrose Planter",
        theme: "Land of Peace & Healing",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph1.png',
        note: "",
        color: ["blue", "green", "gold"],
    },
    {
        name: "Bed of Blooming Lilies",
        theme: "Land of Peace & Healing",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph2.png',
        note: "",
        color: ["white", "green"],
    },
    {
        name: "Cream Mead Stall",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Cart", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph3.png',
        note: "",
        color: ["brown", "blue"],
    },
    {
        name: "Cream Eclair Wall",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Wall"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph4.png',
        note: "",
        color: ["brown", "blue", "cream"],
    },
    {
        name: "Stained Glass Conservatory",
        theme: "Land of Peace & Healing",
        size: "8x8",
        points: 36,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph5.png',
        note: "",
        color: ["white", "green"],
    },
    {
        name: "White Choclate Fence",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph6.png',
        note: "",
        color: ["white", "blue"],
    },
    {
        name: "Honey Waffle Table",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Table", "Cookie Interaction", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Sleeping Vanilla Orchard",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph8.png',
        note: "",
        color: ["yellow", "green", "cream"],
    },
    {
        name: "Vanilla Kingdom Gates",
        theme: "Land of Peace & Healing",
        size: "8x8",
        points: 36,
        tags: ["Gate"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph9.png',
        note: "",
        color: ["white", "brown", "blue"],
    },
    {
        name: "Good Old Clothesline",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph10.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Wafer Laundry Basket",
        theme: "Land of Peace & Healing",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph11.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Cream Sheep",
        theme: "Land of Peace & Healing",
        size: "2x2",
        points: 20,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph12.png',
        note: "",
        color: ["white", "blue"],
    },
    {
        name: "Bed of Primroses",
        theme: "Land of Peace & Healing",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph13.png',
        note: "",
        color: ["blue", "green"],
    },
    {
        name: "Candy Cane Wheelchair",
        theme: "Land of Peace & Healing",
        size: "2x2",
        points: 20,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph14.png',
        note: "",
        color: ["red", "brown"],
    },
    {
        name: "Peaceful Dreamer's Statue",
        theme: "Land of Peace & Healing",
        size: "2x2",
        points: 20,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph15.png',
        note: "",
        color: ["green", "gray"],
    },
    {
        name: "Vanilla Eclair Bench",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph16.png',
        note: "",
        color: ["cream", "brown", "blue"],
    },
    {
        name: "Vanilla Sandwich Table",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph17.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "Simmering Bread Cauldron",
        theme: "Land of Peace & Healing",
        size: "4x4",
        points: 30,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph18.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Wafflebot Workshop",
        theme: "Land of Peace & Healing",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph19.png',
        note: "Cookie Decor for Strawberry Crepe Cookie",
        color: ["cream", "pink", "blue"],
    },
    {
        name: "Crow Tree",
        theme: "Land of Peace & Healing",
        size: "8x8",
        points: 400,
        tags: ["Greenery", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph20.png',
        note: "Cookie Decor for Black Raisin Cookie",
        color: ["brown", "black"],
    },
    {
        name: "Vanilla Orchid Garden",
        theme: "Land of Peace & Healing",
        size: "8x8",
        points: 400,
        tags: ["Building", "Cookie Decor", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph21.png',
        note: "Cookie Decor for Pure Vanilla Cookie",
        color: ["cream", "blue"],
    },
    {
        name: "Vanilla Sanatorium",
        theme: "Land of Peace & Healing",
        size: "16x16",
        points: 440,
        tags: ["Landmark", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lph/lph22.png',
        note: "",
        color: ["cream", "blue", "green"],
    },
    /*Start of Parfaedia Fantasy*/
    {
        name: "Cinnamon Canal",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 0,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf1.png',
        note: "",
        color: ["blue", "brown"],
    },
    {
        name: "Hard Almond Tiles",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cinnamon Sprinkle Road",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf3.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Vanilla Soft Serve Tree",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf4.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Choco Soft Serve Tree",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Banana Soft Serve Tree",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf6.png',
        note: "",
        color: ["yellow"],
    },
    {
        name: "Strawberry Soft Serve Tree",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf7.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Highly Suspicious Wizard",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 20,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf8.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Potted Mandragora",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 25,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf9.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Snowy Blue Light Lamp",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf10.png',
        note: "",
        color: ["brown", "white", "blue"],
    },
    {
        name: "Blue Light Lamp",
        theme: "Parfaedia Fantasy",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf11.png',
        note: "",
        color: ["brown", "blue"],
    },
    {
        name: "Almond Biscuit Bench",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf12.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Mysterious Passage",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 35,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf13.png',
        note: "",
        color: ["purple", "brown", "blue"],
    },
    {
        name: "Ink Cap Alembic",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 35,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf14.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Magic Ingredient Shelf",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 36,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf15.png',
        note: "",
        color: ["purple", "white", "blue"],
    },
    {
        name: "Sweetberry Parfait Table",
        theme: "Parfaedia Fantasy",
        size: "4x4",
        points: 35,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf16.png',
        note: "",
        color: ["pink", "brown"],
    },
    {
        name: "Flying Teaspoon Shop",
        theme: "Parfaedia Fantasy",
        size: "8x8",
        points: 40,
        tags: ["Shop", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf17.png',
        note: "",
        color: ["white", "brown", "blue"],
    },
    {
        name: "Latte Atelier",
        theme: "Parfaedia Fantasy",
        size: "8x8",
        points: 400,
        tags: ["Food", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf18.png',
        note: "Cookie Decor for Latte Cookie",
        color: ["brown"],
    },
    {
        name: "Almond St. 8, Phone Booth",
        theme: "Parfaedia Fantasy",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf19.png',
        note: "Cookie Decor for Almond Cookie",
        color: ["brown"],
    },
    {
        name: "Cream Puff Attic",
        theme: "Parfaedia Fantasy",
        size: "8x8",
        points: 400,
        tags: ["Building", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf20.png',
        note: "Cookie Decor for Cream Puff Cookie",
        color: ["brown", "blue"],
    },
    {
        name: "Parfaitarium",
        theme: "Parfaedia Fantasy",
        size: "16x16",
        points: 440,
        tags: ["Landmark", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/pf/pf21.png',
        note: "",
        color: ["white", "brown", "blue"],
    },
    /*Start of Happy Farm*/
    {
        name: "Biscuit Channel",
        theme: "Happy Farm",
        size: "4x4",
        points: 0,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf1.png',
        note: "",
        color: ["brown", "blue"],
    },
    {
        name: "Biscuitstone Tile",
        theme: "Happy Farm",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Biscuitstone Road",
        theme: "Happy Farm",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Biscuit Hay Sheaf",
        theme: "Happy Farm",
        size: "2x2",
        points: 11,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Jellybean Cart",
        theme: "Happy Farm",
        size: "2x2",
        points: 11,
        tags: ["Food", "Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cream Biscuit Fence",
        theme: "Happy Farm",
        size: "4x4",
        points: 17,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf6.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Biscuit Horsie",
        theme: "Happy Farm",
        size: "4x4",
        points: 17,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Blueberry Cart",
        theme: "Happy Farm",
        size: "4x4",
        points: 17,
        tags: ["Cart", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf8.png',
        note: "",
        color: [" "],
    },
    {
        name: "Biscuit Hay Wagon",
        theme: "Happy Farm",
        size: "4x4",
        points: 17,
        tags: ["Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf9.png',
        note: "",
        color: ["brown", "blue"],
    },
    {
        name: "Round Bee Hive",
        theme: "Happy Farm",
        size: "2x2",
        points: 17,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf10.png',
        note: "",
        color: ["yellow", "brown"],
    },
    {
        name: "Fluffy Bread Cart",
        theme: "Happy Farm",
        size: "8x8",
        points: 22,
        tags: ["Cart", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hf/hf11.png',
        note: "",
        color: ["brown"],
    },
    /*Start of Acorn Village*/
    {
        name: "Choco Acorn",
        theme: "Acorn Village",
        size: "2x2",
        points: 12,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Acorn Vine Lamp",
        theme: "Acorn Village",
        size: "2x2",
        points: 12,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Autumnal Acorn Lamp",
        theme: "Acorn Village",
        size: "2x2",
        points: 12,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Simple Rope Fence",
        theme: "Acorn Village",
        size: "4x4",
        points: 17,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Waffle Acorn Storage",
        theme: "Acorn Village",
        size: "4x4",
        points: 17,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Acorn Oak",
        theme: "Acorn Village",
        size: "4x4",
        points: 17,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av6.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Acorn House",
        theme: "Acorn Village",
        size: "4x4",
        points: 17,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av7.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Clover Cookie's Forset Music Festival",
        theme: "Acorn Village",
        size: "8x8",
        points: 180,
        tags: ["Greenery", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/av/av8.png',
        note: "Cookie Decor for Clover Cookie",
        color: ["green", "brown"],
    },
    /*Start for Gnome's Life*/
    {
        name: "Watering Can Sugar Gnome",
        theme: "Gnome's Life",
        size: "2x2",
        points: 12,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gl/gl1.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Tripped Over Sugar Gnome",
        theme: "Gnome's Life",
        size: "2x2",
        points: 12,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gl/gl2.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Torch Sugar Gnome",
        theme: "Gnome's Life",
        size: "2x2",
        points: 12,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gl/gl3.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Standing Sugar Gnome",
        theme: "Gnome's Life",
        size: "2x2",
        points: 12,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gl/gl4.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Reading Sugar Gnome",
        theme: "Gnome's Life",
        size: "2x2",
        points: 12,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gl/gl5.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Mustache Sugar Gnome",
        theme: "Gnome's Life",
        size: "2x2",
        points: 12,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gl/gl6.png',
        note: "",
        color: ["red"],
    },
    /*Start of Market Square*/
    {
        name: "Chocostone Tile",
        theme: "Market Square",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Chocostone Road",
        theme: "Market Square",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Jampie Bench",
        theme: "Market Square",
        size: "2x2",
        points: 13,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cotton Candy Cart",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food", "Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms4.png',
        note: "",
        color: ["pink", "blue"],
    },
    {
        name: "Berry Box",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms5.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Honeycomb Box",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms6.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Veggie Basket",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Roll Cake Cutting Board",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms8.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Lemon Drink Container",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms9.png',
        note: "",
        color: ["brown", "yellow"],
    },
    {
        name: "Milk Cart",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food", "Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms10.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Omurice Table",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Food", "Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms11.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Jampie Table",
        theme: "Market Square",
        size: "4x4",
        points: 19,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms12.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "This'n'That' Emporium",
        theme: "Market Square",
        size: "8x8",
        points: 25,
        tags: ["Shop"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms13.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Colorful Flower Shop",
        theme: "Market Square",
        size: "8x8",
        points: 25,
        tags: ["Shop", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms14.png',
        note: "",
        color: ["green", "pink", "purple"],
    },
    {
        name: "Fresh Veggie Shop",
        theme: "Market Square",
        size: "8x8",
        points: 25,
        tags: ["Shop", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms15.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Jelly Meat Stall",
        theme: "Market Square",
        size: "8x8",
        points: 25,
        tags: ["Shop", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms16.png',
        note: "",
        color: ["red", "brown"],
    },
    {
        name: "Caramel Fountain",
        theme: "Market Square",
        size: "8x8",
        points: 25,
        tags: ["Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ms/ms17.png',
        note: "",
        color: ["brown", "blue", "green"],
    },
    /*Start of Lunar New Year*/
    {
        name: "Black Sesame Dasik Tile",
        theme: "Lunar New Year",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Kite Sugar Gnome",
        theme: "Lunar New Year",
        size: "2x2",
        points: 20,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny2.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Jujube Rice Cake Wall",
        theme: "Lunar New Year",
        size: "4x4",
        points: 30,
        tags: ["Wall"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny3.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Persimmon Jar",
        theme: "Lunar New Year",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny4.png',
        note: "",
        color: ["orange"],
    },
    {
        name: "Painted Folding Screen",
        theme: "Lunar New Year",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Migwa Cedar",
        theme: "Lunar New Year",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny6.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Jelly Pine Tree",
        theme: "Lunar New Year",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny7.png',
        note: "",
        color: ["brown", "red", "green"],
    },
    {
        name: "Yakgwa Bench",
        theme: "Lunar New Year",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny8.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Yakgwa Table",
        theme: "Lunar New Year",
        size: "4x4",
        points: 30,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny9.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Lucky Palanquin",
        theme: "Lunar New Year",
        size: "8x8",
        points: 36,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny10.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Sujeonggwa Pond",
        theme: "Lunar New Year",
        size: "8x8",
        points: 35,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny11.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Dagwa Pavilion",
        theme: "Lunar New Year",
        size: "8x8",
        points: 40,
        tags: ["Building", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny12.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Spirit Fox Swing",
        theme: "Lunar New Year",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/lny/lny13.png',
        note: "Cookie Decor for Kumiho Cookie",
        color: ["white", "red"],
    },
    /*Start of Atlas of Trees*/
    {
        name: "Snowfall Tree Stump",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot1.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Red Berry Bush",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot2.png',
        note: "",
        color: ["white", "green"],
    },

    {
        name: "Jolly Snowfruit Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot3.png',
        note: "",
        color: ["white", "green", "brown"],
    },
    {
        name: "Frosted Pine Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot4.png',
        note: "",
        color: ["white", "green", "brown"],
    },
    {
        name: "Jolly Round Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot5.png',
        note: "",
        color: ["white", "green", "brown"],
    },
    {
        name: "Autumn Willow Tree",
        theme: "Atlas of Trees",
        size: "6x6",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot6.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Autumn Tree with a Clover",
        theme: "Atlas of Trees",
        size: "6x6",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot7.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Amber Autumn Tree",
        theme: "Atlas of Trees",
        size: "6x6",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot8.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Autumn Clover Leaf Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot9.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Palm Maple Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot10.png',
        note: "",
        color: ["red", "brown"],
    },
    {
        name: "Eerie Dried-up Tree",
        theme: "Atlas of Trees",
        size: "6x6",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot11.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Sleeping Sage Stump",
        theme: "Atlas of Trees",
        size: "3x3",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot12.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Resting Tree Stump",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot13.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Ivied Stump",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot14.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Sleeping Log",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot15.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Young Evergreen Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot16.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Tapered Garden Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot17.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Rebellious Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot18.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Clover Leaf Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot19.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Verdant Ginkogo Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot20.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Pointy Pine Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot21.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Fluffy Pine Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot22.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Shaggy Evergreen Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot23.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Lie Detector Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot24.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Round Evergreen Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot25.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Frightened Dried-up Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot26.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Exhausted Dried-up Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot27.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Large Willow Tree",
        theme: "Atlas of Trees",
        size: "6x6",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot28.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Mushroom-adorned Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot29.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Sheltering Garden Tree",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot30.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Big Tree with a Clover",
        theme: "Atlas of Trees",
        size: "6x6",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot31.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Big Tree with a Mushroom",
        theme: "Atlas of Trees",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/aot/aot32.png',
        note: "",
        color: ["green", "brown"],
    },
    /*Start of Tea Cup Hamlet*/
    {
        name: "Spring Flowers",
        theme: "Tea Cup Hamlet",
        size: "4x4",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tch/tch1.png',
        note: "",
        color: ["green", "yellow"],
    },
    {
        name: "Blue Sage Tea Cup House",
        theme: "Tea Cup Hamlet",
        size: "4x4",
        points: 20,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tch/tch2.png',
        note: "",
        color: ["green", "white", "blue"],
    },
    {
        name: "Cherry Teapot House",
        theme: "Tea Cup Hamlet",
        size: "4x4",
        points: 20,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tch/tch3.png',
        note: "",
        color: ["green", "white"],
    },
    {
        name: "Cherry Tea Cup House",
        theme: "Tea Cup Hamlet",
        size: "4x4",
        points: 20,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tch/tch4.png',
        note: "",
        color: ["green", "white"],
    },
    {
        name: "Creamer Pond",
        theme: "Tea Cup Hamlet",
        size: "4x4",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tch/tch5.png',
        note: "",
        color: ["green", "white"],
    },
    /*Start of Witches & Ghosts*/
    {
        name: "Melted Choco Tree",
        theme: "Witches & Ghosts",
        size: "4x4",
        points: 21,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/wg/wg1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Gloomy Mausoleum",
        theme: "Witches & Ghosts",
        size: "4x4",
        points: 21,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/wg/wg2.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Witch's Oven Photo Zone",
        theme: "Witches & Ghosts",
        size: "8x8",
        points: 28,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/wg/wg3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Bleak Sugar Cemetery",
        theme: "Witches & Ghosts",
        size: "8x8",
        points: 28,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/wg/wg4.png',
        note: "",
        color: ["gray", "purple"],
    },
    {
        name: "Blackberry Cookie's Midnight Fireplace",
        theme: "Witches & Ghosts",
        size: "8x8",
        points: 240,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/wg/wg5.png',
        note: "Cookie Decor for both Blackberry Cookie and Onion Cookie",
        color: ["purple"],
    },
    {
        name: "Eerie Haunted House",
        theme: "Witches & Ghosts",
        size: "16x16",
        points: 200,
        tags: ["Landmark", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/wg/wg6.png',
        note: "",
        color: ["gray", "purple"],
    },
    /*Start of Blade & Magic*/
    {
        name: "Weapon Rack",
        theme: "Blade & Magic",
        size: "4x4",
        points: 22,
        tags: ["Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Magic Tome",
        theme: "Blade & Magic",
        size: "4x4",
        points: 22,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Bear Jelly Black Knight",
        theme: "Blade & Magic",
        size: "4x4",
        points: 22,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm3.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Epic Puppet Show",
        theme: "Blade & Magic",
        size: "8x8",
        points: 29,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm4.png',
        note: "",
        color: ["brown", "gray"],
    },
    {
        name: "Sage's Round Table",
        theme: "Blade & Magic",
        size: "6x6",
        points: 38,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Green Territory's Banner",
        theme: "Blade & Magic",
        size: "2x2",
        points: 20,
        tags: ["Banner"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm6.png',
        note: "",
        color: ["green", "gold"],
    },
    {
        name: "Excavated Warrior's Statue",
        theme: "Blade & Magic",
        size: "4x4",
        points: 30,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm7.png',
        note: "",
        color: ["gray", "brown"],
    },
    {
        name: "Red Territory's Banner",
        theme: "Blade & Magic",
        size: "2x2",
        points: 20,
        tags: ["Banner"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm8.png',
        note: "",
        color: ["red", "gold"],
    },
    {
        name: "Warrior's Stone Bench",
        theme: "Blade & Magic",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm9.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Blue Territory's Banner",
        theme: "Blade & Magic",
        size: "2x2",
        points: 20,
        tags: ["Banner"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm10.png',
        note: "",
        color: ["blue", "gold"],
    },
    {
        name: "Morning Training Ground",
        theme: "Blade & Magic",
        size: "4x4",
        points: 30,
        tags: ["Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm11.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Magical Blue Pointy Hat Tower",
        theme: "Blade & Magic",
        size: "6x6",
        points: 38,
        tags: ["Tower"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm12.png',
        note: "",
        color: ["brown", "blue"],
    },
    {
        name: "Magic Wisp",
        theme: "Blade & Magic",
        size: "2x2",
        points: 20,
        tags: ["Fire"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm13.png',
        note: "",
        color: ["blue", "gray"],
    },
    {
        name: "Curious Laboratory",
        theme: "Blade & Magic",
        size: "8x8",
        points: 240,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm14.png',
        note: "Cookie Decor for both Wizard Cookie and Alchemist Cookie",
        color: ["purple", "brown"],
    },
    {
        name: "Madeleine Cookie's Altar",
        theme: "Blade & Magic",
        size: "8x8",
        points: 300,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm15.png',
        note: "Cookie Decor for Madeleine Cookie",
        color: ["cream", "brown"],
    },
    {
        name: "Excavation Tent",
        theme: "Blade & Magic",
        size: "8x8",
        points: 400,
        tags: ["Tent", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm16.png',
        note: "Cookie Decor for Eclair Cookie",
        color: ["green", "brown"],
    },
    {
        name: "Molten Magma Mountain",
        theme: "Blade & Magic",
        size: "16x16",
        points: 230,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bm/bm17.png',
        note: "",
        color: ["brown", "red"],
    },
    /*Start of Kingdom of Snow & Ice*/
    {
        name: "Snowy Road",
        theme: "Kingdom of Snow & Ice",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi1.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Frosty Tiles",
        theme: "Kingdom of Snow & Ice",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi2.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Slippery Ice Road",
        theme: "Kingdom of Snow & Ice",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi3.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Snowy Tree",
        theme: "Kingdom of Snow & Ice",
        size: "4x4",
        points: 23,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi4.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "De-iceing Tools",
        theme: "Kingdom of Snow & Ice",
        size: "4x4",
        points: 23,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi5.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Strawberry Snowman",
        theme: "Kingdom of Snow & Ice",
        size: "4x4",
        points: 23,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi6.png',
        note: "",
        color: ["white", "pink"],
    },
    {
        name: "Mint Choco Snowman",
        theme: "Kingdom of Snow & Ice",
        size: "4x4",
        points: 23,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi7.png',
        note: "",
        color: ["white", "green"],
    },
    {
        name: "Ice Cream Igloo",
        theme: "Kingdom of Snow & Ice",
        size: "8x8",
        points: 30,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi8.png',
        note: "",
        color: ["white", "blue"],
    },
    {
        name: "Snow Sugar Cookie's Winter Guest",
        theme: "Kingdom of Snow & Ice",
        size: "8x8",
        points: 300,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi9.png',
        note: "Cookie Decor for Snow Sugar Cookie",
        color: ["white"],
    },
    {
        name: "Everwinter Snow Globe",
        theme: "Kingdom of Snow & Ice",
        size: "16x16",
        points: 260,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ksi/ksi10.png',
        note: "",
        color: ["white"],
    },
    /*Start of Luxurious Juice Salon*/
    {
        name: "Chocowood Tiles",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Modern Choco Menu Board",
        theme: "Luxurious Juice Salon",
        size: "2x2",
        points: 16,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Golden Cheese Plant",
        theme: "Luxurious Juice Salon",
        size: "2x2",
        points: 16,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs3.png',
        note: "",
        color: ["green", "gold"],
    },
    {
        name: "Luxurious Croissant Sofa",
        theme: "Luxurious Juice Salon",
        size: "2x2",
        points: 16,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Caramel Butter Gramophone",
        theme: "Luxurious Juice Salon",
        size: "2x2",
        points: 16,
        tags: ["Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs5.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Stained-Glass Pattern",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs6.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cheese Pie Table",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: ["Table"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs7.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Luxurious Mille-feuille Shelf",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs8.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Cacaoken Aging Barrel",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs9.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Dark Choco Harpsichord",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: ["Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs10.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Bottled Applie Pie Cellar",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs11.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Luxurious Armchair Set",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs12.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Modern Choco Table Set",
        theme: "Luxurious Juice Salon",
        size: "4x4",
        points: 23,
        tags: ["Cookie Interaction", "Table"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs13.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Sparkling Cookie's Juice Bar",
        theme: "Luxurious Juice Salon",
        size: "8x8",
        points: 360,
        tags: ["Cookie Decor", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs14.png',
        note: `Cookie Decor for Sparkling Cookie, Milk Cookie
        and Vampire cookie. Up to 2 other cookies can interact
        with the stools.`,
        color: ["brown", "gold"],
    },
    {
        name: "Brewing Laboratory",
        theme: "Luxurious Juice Salon",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ljs/ljs15.png',
        note: "Cookie Decor for Espresso Cookie",
        color: ["brown"],
    },
    /*Start for Grand Dinner Party*/
    {
        name: "Cookie & Cream Tiles",
        theme: "Grand Dinner Party",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp1.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Red Velvet Carpet",
        theme: "Grand Dinner Party",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp2.png',
        note: "",
        color: ["red", "white"],
    },
    {
        name: "Green Tea Pillar",
        theme: "Grand Dinner Party",
        size: "2x2",
        points: 16,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp3.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Pudding Cart",
        theme: "Grand Dinner Party",
        size: "2x2",
        points: 16,
        tags: ["Cart", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Luxurious Garden Plant",
        theme: "Grand Dinner Party",
        size: "2x2",
        points: 16,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp5.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Super-Luxurious Vase",
        theme: "Grand Dinner Party",
        size: "2x2",
        points: 16,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp6.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Luxurious Party Vase",
        theme: "Grand Dinner Party",
        size: "2x2",
        points: 16,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp7.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Luxurious Afternoon Tea Set",
        theme: "Grand Dinner Party",
        size: "4x4",
        points: 24,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp8.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Jelly Steak Table",
        theme: "Grand Dinner Party",
        size: "4x4",
        points: 24,
        tags: ["Table", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp9.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Luxurious 3-Tier Cake",
        theme: "Grand Dinner Party",
        size: "4x4",
        points: 24,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp10.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Grand Dinner Table",
        theme: "Grand Dinner Party",
        size: "8x8",
        points: 32,
        tags: ["Table", "Cookie Interaction", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp11.png',
        note: "",
        color: ["purple", "white"],
    },
    {
        name: "Custard Cookie III's Throne",
        theme: "Grand Dinner Party",
        size: "8x8",
        points: 800,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gdp/gdp12.png',
        note: "Cookie Decor for Custard Cookie",
        color: ["gold", "blue"],
    },
    /*Start of Sculpture Park*/
    {
        name: "Sugar Marble Waterway",
        theme: "Sculpture Park",
        size: "4x4",
        points: 0,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp1.png',
        note: "",
        color: ["gray", "blue"],
    },
    {
        name: "Jellystone Tiles",
        theme: "Sculpture Park",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp2.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Almond Garden Tree",
        theme: "Sculpture Park",
        size: "2x2",
        points: 17,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp3.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Conical Garden Plant",
        theme: "Sculpture Park",
        size: "2x2",
        points: 17,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp4.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Wisteria Streetlight",
        theme: "Sculpture Park",
        size: "2x2",
        points: 17,
        tags: ["Lamp", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp5.png',
        note: "",
        color: ["brown", "gold", "purple"],
    },
    {
        name: "Blue Banner Lantern",
        theme: "Sculpture Park",
        size: "2x2",
        points: 17,
        tags: ["Banner", "Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp6.png',
        note: "",
        color: ["brown", "gold", "blue"],
    },
    {
        name: "Sugar Swan Statue",
        theme: "Sculpture Park",
        size: "4x4",
        points: 17,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp7.png',
        note: "",
        color: ["gray", "blue"],
    },
    {
        name: "Cubic Garden Plant",
        theme: "Sculpture Park",
        size: "4x4",
        points: 25,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp8.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Sugar Marble Wall",
        theme: "Sculpture Park",
        size: "4x4",
        points: 25,
        tags: ["Wall"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp9.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Sugar Marble Seat",
        theme: "Sculpture Park",
        size: "4x4",
        points: 25,
        tags: ["Bench"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp10.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Sugar Marble Bench",
        theme: "Sculpture Park",
        size: "4x4",
        points: 25,
        tags: ["Bench"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp11.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Pure Vanilla Cookie Statue",
        theme: "Sculpture Park",
        size: "4x4",
        points: 25,
        tags: ["Statue", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp12.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Rhombic Garden Plant",
        theme: "Sculpture Park",
        size: "8x8",
        points: 33,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp13.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Sugar Marble Jelly Dragon",
        theme: "Sculpture Park",
        size: "4x4",
        points: 33,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp14.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Sugar Marble Jelly Lion",
        theme: "Sculpture Park",
        size: "4x4",
        points: 33,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp15.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Dreaming Jelly Lion Statue",
        theme: "Sculpture Park",
        size: "16x16",
        points: 290,
        tags: ["Landmark", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sp/sp16.png',
        note: "",
        color: ["gray", "blue"],
    },
    /*Start of St. Pastry Order*/
    {
        name: "Pastry Peonies",
        theme: "St. Pastry Order",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo1.png',
        note: "",
        color: ["purple", "white"],
    },
    {
        name: "Tribunal Candle",
        theme: "St. Pastry Order",
        size: "2x2",
        points: 20,
        tags: ["Candle"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo2.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Secret Shrine",
        theme: "St. Pastry Order",
        size: "4x4",
        points: 36,
        tags: ["Candle"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo3.png',
        note: "",
        color: ["purple", "gray"],
    },
    {
        name: "Cathedral Pew",
        theme: "St. Pastry Order",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo4.png',
        note: "",
        color: ["purple", "gray"],
    },
    {
        name: "Pie-That-Gave-Up",
        theme: "St. Pastry Order",
        size: "4x4",
        points: 30,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cookie Tray of Doom",
        theme: "St. Pastry Order",
        size: "4x4",
        points: 30,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo6.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Strawberry Choco Pansies",
        theme: "St. Pastry Order",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo7.png',
        note: "",
        color: ["gray", "red"],
    },
    {
        name: "Cream Cake Stand",
        theme: "St. Pastry Order",
        size: "4x4",
        points: 36,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo8.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Fluffy Barking Cake Hound",
        theme: "St. Pastry Order",
        size: "2x2",
        points: 350,
        tags: ["Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo9.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Forgotten Piece of Cake",
        theme: "St. Pastry Order",
        size: "8x8",
        points: 420,
        tags: ["Food", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo10.png',
        note: "Cookie Decor for Red Velvet Cookie",
        color: ["red", "gray"],
    },
    {
        name: "Clandestine Rendezvous",
        theme: "St. Pastry Order",
        size: "8x8",
        points: 420,
        tags: ["Cookie Decor", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo11.png',
        note: "Cookie Decor for Pastry Cookie; another cookies can also interact simultaneously",
        color: ["gray", "purple"],
    },
    {
        name: "Ominous Cake Tower",
        theme: "St. Pastry Order",
        size: "16x16",
        points: 450,
        tags: ["Landmark", "Food", "Tower"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/spo/spo12.png',
        note: "",
        color: ["red"],
    },
    /*Start of Flower Garden*/
    {
        name: "Shrub",
        theme: "Flower Garden",
        size: "2x2",
        points: 17,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg1.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Hydrangea",
        theme: "Flower Garden",
        size: "2x2",
        points: 17,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg2.png',
        note: "",
        color: ["green", "purple"],
    },
    {
        name: "Strawberrose Flowerbed",
        theme: "Flower Garden",
        size: "2x2",
        points: 17,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg3.png',
        note: "",
        color: ["green", "red"],
    },
    {
        name: "Cream Rose Flowerbed",
        theme: "Flower Garden",
        size: "2x2",
        points: 17,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg4.png',
        note: "",
        color: ["green", "pink"],
    },
    {
        name: "Zinnia Flowerbed",
        theme: "Flower Garden",
        size: "2x2",
        points: 17,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg5.png',
        note: "",
        color: ["green", "yellow"],
    },
    {
        name: "Daffodil Flowerbed",
        theme: "Flower Garden",
        size: "2x2",
        points: 17,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg6.png',
        note: "",
        color: ["green", "white"],
    },
    {
        name: "Herb Terrace",
        theme: "Flower Garden",
        size: "8x8",
        points: 360,
        tags: ["Greenery", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg7.png',
        note: "Cookie Decor for Herb Cookie",
        color: ["green", "brown"],
    },
    {
        name: "Morning Dew Garden",
        theme: "Flower Garden",
        size: "16x16",
        points: 320,
        tags: ["Greenery", "Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fg/fg8.png',
        note: "",
        color: ["green", "brown"],
    },
    /*Start for Garden of Delights*/
    {
        name: "Pink Water Tiles",
        theme: "Garden of Delights",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd1.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Macaron Bench",
        theme: "Garden of Delights",
        size: "2x2",
        points: 18,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd2.png',
        note: "",
        color: ["cream", "purple"],
    },
    {
        name: "Soft Serve Horsey",
        theme: "Garden of Delights",
        size: "2x2",
        points: 18,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd3.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Pastel Postbox",
        theme: "Garden of Delights",
        size: "2x2",
        points: 18,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd4.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Lovely Phone Booth",
        theme: "Garden of Delights",
        size: "2x2",
        points: 18,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd5.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Lovely Photo Zone",
        theme: "Garden of Delights",
        size: "4x4",
        points: 26,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd6.png',
        note: "",
        color: ["white", "cream"],
    },
    {
        name: "Montblanc Dessert Table",
        theme: "Garden of Delights",
        size: "4x4",
        points: 26,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd7.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Cotton Candy Tree",
        theme: "Garden of Delights",
        size: "4x4",
        points: 26,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd8.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Lovely Dressing Room",
        theme: "Garden of Delights",
        size: "8x8",
        points: 300,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd9.png',
        note: "Cookie Decor for Princess Cookie and Knight Cookie",
        color: ["red", "gold"],
    },
    {
        name: "Mint Choco Cookie's Concert Hall",
        theme: "Garden of Delights",
        size: "8x8",
        points: 360,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd10.png',
        note: "Cookie Decor for Mint Choco Cookie",
        color: ["green", "brown"],
    },
    {
        name: "Grand Dessert Tower",
        theme: "Garden of Delights",
        size: "16x16",
        points: 350,
        tags: ["Food", "Landmark", "Tower"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/gd/gd11.png',
        note: "",
        color: ["pink"],
    },
    /*Start of Bustling Amusement Park*/
    {
        name: "Balloon Bear Jelly",
        theme: "Bustling Amusement Park",
        size: "2x2",
        points: 18,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap1.png',
        note: "",
        color: ["yellow"],
    },
    {
        name: "Free Hug Bear Jelly",
        theme: "Bustling Amusement Park",
        size: "2x2",
        points: 18,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap2.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Water Bomb Board",
        theme: "Bustling Amusement Park",
        size: "4x4",
        points: 27,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap3.png',
        note: "",
        color: [""],
    },
    {
        name: "Rocket Rider",
        theme: "Bustling Amusement Park",
        size: "4x4",
        points: 27,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap4.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Cherry Cream Fence",
        theme: "Bustling Amusement Park",
        size: "4x4",
        points: 27,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap5.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Colorful Balloon Stand",
        theme: "Bustling Amusement Park",
        size: "4x4",
        points: 27,
        tags: ["Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap6.png',
        note: "",
        color: ["red", "brown"],
    },
    {
        name: "Jelly Horsey Carousel",
        theme: "Bustling Amusement Park",
        size: "8x8",
        points: 36,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap7.png',
        note: "",
        color: ["green", "brown", "yellow"],
    },
    {
        name: "Creamy Rainbow Arch",
        theme: "Bustling Amusement Park",
        size: "8x8",
        points: 400,
        tags: ["Arch", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap8.png',
        note: "Cookie Decor for Cream Unicorn Cookie",
        color: ["pink", "purple"],
    },
    {
        name: "Firecracker Cupcake",
        theme: "Bustling Amusement Park",
        size: "8x8",
        points: 300,
        tags: ["Food", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap9.png',
        note: "Cookie Decor for Cherry Cookie and Gumball Cookie",
        color: ["pink", "red"],
    },
    {
        name: "Ferris Wheel",
        theme: "Bustling Amusement Park",
        size: "16x16",
        points: 410,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/bap/bap10.png',
        note: "",
        color: ["pink"],
    },
    /*Start of Pew-pew Arcade*/
    {
        name: "Jellybean Vending Machine",
        theme: "Pew-Pew Arcade",
        size: "2x2",
        points: 19,
        tags: ["Machine"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ppa/ppa1.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Mighty Hammer Game",
        theme: "Pew-Pew Arcade",
        size: "4x4",
        points: 19,
        tags: ["Machine"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ppa/ppa2.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Gumball Machine",
        theme: "Pew-Pew Arcade",
        size: "4x4",
        points: 28,
        tags: ["Machine"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ppa/ppa3.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Bubblegum Sniper Game",
        theme: "Pew-Pew Arcade",
        size: "4x4",
        points: 28,
        tags: ["Machine"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ppa/ppa4.png',
        note: "",
        color: ["blue", "brown", "red"],
    },
    {
        name: "Muscle Cookie's Gym Machine",
        theme: "Pew-Pew Arcade",
        size: "8x8",
        points: 300,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ppa/ppa5.png',
        note: "Cookie Decor for Muscle Cookie and Pancake Cookie",
        color: ["brown"],
    },
    {
        name: "Gumball Arcade Machine",
        theme: "Pew-Pew Arcade",
        size: "16x16",
        points: 410,
        tags: ["Machine", "Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ppa/ppa6.png',
        note: "",
        color: ["pink", "red"],
    },
    /*Start of Crimson Badlands*/
    {
        name: "Dark Choco Tiles of Darkness",
        theme: "Crimson Badlands",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Candy Cane Torch",
        theme: "Crimson Badlands",
        size: "2x2",
        points: 19,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb2.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Tilted Candy Cane Thorn",
        theme: "Crimson Badlands",
        size: "4x4",
        points: 29,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb3.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Slanted Candy Cane Thorn",
        theme: "Crimson Badlands",
        size: "4x4",
        points: 29,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb4.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Voodoo Doll",
        theme: "Crimson Badlands",
        size: "4x4",
        points: 29,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb5.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Melting Choco Tree",
        theme: "Crimson Badlands",
        size: "4x4",
        points: 29,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb6.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Round Table of Darkness",
        theme: "Crimson Badlands",
        size: "8x8",
        points: 400,
        tags: ["Table", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb7.png',
        note: "Cookie Decor for Dark Choco, Pomegranate, Licorice and Posion Mushroom Cookie",
        color: ["brown", "purple"],
    },
    {
        name: "Dark Lord's Castle",
        theme: "Crimson Badlands",
        size: "16x16",
        points: 440,
        tags: ["Building", "Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/cb/cb8.png',
        note: "",
        color: ["brown", "red"],
    },
    /*Start of Starry Night*/
    {
        name: "Constellation Tiles",
        theme: "Starry Night",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn1.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Milky Waterway",
        theme: "Starry Night",
        size: "4x4",
        points: 0,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn2.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Starlight Lantern",
        theme: "Starry Night",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn3.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "White Star Jelly Tree",
        theme: "Starry Night",
        size: "4x4",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn4.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Golden Croissant Bench",
        theme: "Starry Night",
        size: "4x4",
        points: 20,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn5.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Little Telescope",
        theme: "Starry Night",
        size: "4x4",
        points: 29,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn6.png',
        note: "",
        color: ["purple", "gold"],
    },
    {
        name: "Starlight Carousel",
        theme: "Starry Night",
        size: "8x8",
        points: 39,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn7.png',
        note: "",
        color: ["purple", "gold"],
    },
    {
        name: "Star Candy Observatory",
        theme: "Starry Night",
        size: "16x16",
        points: 470,
        tags: ["Landmark", "Tower"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sn/sn8.png',
        note: "",
        color: ["purple", "gold"],
    },
    /*Start of Industrial Adventure*/
    {
        name: "Caramel Streetlight",
        theme: "Industrial Adventure",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia1.png',
        note: "",
        color: ["brown", "yellow"],
    },
    {
        name: "Red Jelly Fire Hydrant",
        theme: "Industrial Adventure",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia2.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Cacao Manhole Lid",
        theme: "Industrial Adventure",
        size: "2x2",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cherry Bomb Cannon",
        theme: "Industrial Adventure",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cacao Butter Plane",
        theme: "Industrial Adventure",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia5.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Caramel Clock Tower",
        theme: "Industrial Adventure",
        size: "8x8",
        points: 40,
        tags: ["Tower"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia6.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Choco-Coated Hangar",
        theme: "Industrial Adventure",
        size: "8x8",
        points: 50,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia7.png',
        note: "",
        color: ["red", "brown", "gold"],
    },
    {
        name: "Sheriff's Office",
        theme: "Industrial Adventure",
        size: "8x8",
        points: 400,
        tags: ["Building", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia8.png',
        note: "Cookie Decor for both Rye Cookie and Chili Pepper Cookie",
        color: ["brown"],
    },
    {
        name: "Croissant Zeppelin",
        theme: "Industrial Adventure",
        size: "16x16",
        points: 500,
        tags: ["Landmark", ],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ia/ia9.png',
        note: "",
        color: ["brown", "gold"],
    },
    /*Start of Tropical Island*/
    {
        name: "Seaside Sand Path",
        theme: "Tropical Island",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti1.png',
        note: "",
        color: ["green", "yellow"],
    },
    {
        name: "Fruit Cocktail Bridge",
        theme: "Tropical Island",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti2.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Orange Biscuit Bridge",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Fresh Fruit Juice Cart",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Cookie Interaction", "Shop"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti4.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Welcomed Sugar Gnome",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti5.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Welcoming Sugar Gnome",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti6.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Hibiscus Bush",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti7.png',
        note: "",
        color: ["green", "pink"],
    },
    {
        name: "Lime Table",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Greenery", "Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti8.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Bamboo Fence",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti9.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Limecoco Palm Tree",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti10.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Candy Corn Hermit Crab",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti11.png',
        note: "",
        color: ["orange"],
    },
    {
        name: "Monstera Bush",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti12.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Coconut Beach Welcome Sign",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti13.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Watermelon Sunbed",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti14.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Mango Fish",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Animal", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti15.png',
        note: "",
        color: ["yellow"],
    },
    {
        name: "Unicorn Tube",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti16.png',
        note: "",
        color: ["white", "pink"],
    },
    {
        name: "Watermelon Fish",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Animal", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti17.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Jelly Shark Fin",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Animal", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti18.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Faded Message in a Bottle",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti19.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Conch of the Sea",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti20.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Jelly Starfish",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti21.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Juicy Ice Pop Snowboard",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti22.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Beach Picnic Set",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti23.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Beachside Castle",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti24.png',
        note: "",
        color: ["yellow"],
    },
    {
        name: "Plumeria Flowerbed",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti25.png',
        note: "",
        color: ["green", "white"],
    },
    {
        name: "Durianeer Tree Fort",
        theme: "Tropical Island",
        size: "6x6",
        points: 32,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti26.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Green'n'Purple Plant",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti27.png',
        note: "",
        color: ["green", "pink"],
    },
    {
        name: "Coconut Palm",
        theme: "Tropical Island",
        size: "6x6",
        points: 32,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti28.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Durianeer Crow's Nest",
        theme: "Tropical Island",
        size: "6x6",
        points: 32,
        tags: ["Flag"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti29.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Durianeer Cannonball",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: ["Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti30.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Durianeer Cannon",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti31.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Durianeer Treasure Chest",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti32.png',
        note: "",
        color: ["brown", "gold"],
    },
    {
        name: "Durian Totem",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti33.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Pop-up Skeleton",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti34.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Sturdy Barrel",
        theme: "Tropical Island",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti35.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Dinghy Feast",
        theme: "Tropical Island",
        size: "6x6",
        points: 32,
        tags: ["Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti36.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Silent Palm Tree Prison",
        theme: "Tropical Island",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti37.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Oh no! It's the Durianeers!",
        theme: "Tropical Island",
        size: "8x8",
        points: 36,
        tags: ["Water", "Flag"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti38.png',
        note: "",
        color: ["yellow", "green"],
    },
    {
        name: "Silk and Satin",
        theme: "Tropical Island",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti39.png',
        note: "Cookie Decor for Lilac Cookie",
        color: ["green", "purple"],
    },
    {
        name: "Mango Canoe",
        theme: "Tropical Island",
        size: "8x8",
        points: 400,
        tags: ["Water", "Cookie Decor", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti40.png',
        note: "Cookie Decor for Mango Cookie; a second cookie can also interact",
        color: ["yellow"],
    },
    {
        name: "Rookie Raft",
        theme: "Tropical Island",
        size: "8x8",
        points: 400,
        tags: ["Water", "Cookie Decor", "Flag"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti41.png',
        note: "Cookie Decor for Sorbet Shark Cookie",
        color: ["brown"],
    },
    {
        name: "Dream of the Tower",
        theme: "Tropical Island",
        size: "16x16",
        points: 1200,
        tags: ["Water", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti42.png',
        note: "Cookie Decor for Sea Fairy Cookie",
        color: ["blue"],
    },
    {
        name: "Skull Island Resort",
        theme: "Tropical Island",
        size: "16x16",
        points: 440,
        tags: ["Landmark", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ti/ti43.png',
        note: "",
        color: ["gray", "green", "yellow"],
    },
    /*Start of Summer Music Festival*/
    {
        name: "Mini Pie Chair",
        theme: "Summer Music Festival",
        size: "2x2",
        points: 20,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf1.png',
        note: "",
        color: ["brown", "pink"],
    },
    {
        name: "Candy Fence",
        theme: "Summer Music Festival",
        size: "4x4",
        points: 30,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf2.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Icy Soda Cart",
        theme: "Summer Music Festival",
        size: "4x4",
        points: 30,
        tags: ["Food", "Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf3.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Paru Paru ☆ Goods Stand",
        theme: "Summer Music Festival",
        size: "4x4",
        points: 30,
        tags: ["Table"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf4.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Candy Spotlight",
        theme: "Summer Music Festival",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf5.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Cherry Cone Mic",
        theme: "Summer Music Festival",
        size: "2x2",
        points: 20,
        tags: ["Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf6.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Sweet Synth",
        theme: "Summer Music Festival",
        size: "4x4",
        points: 30,
        tags: ["Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf7.png',
        note: "",
        color: ["purple", "pink"],
    },
    {
        name: "Apple Bass",
        theme: "Summer Music Festival",
        size: "2x2",
        points: 20,
        tags: ["Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf8.png',
        note: "",
        color: ["green", "red"],
    },
    {
        name: "Candy Drums",
        theme: "Summer Music Festival",
        size: "4x4",
        points: 30,
        tags: ["Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf9.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Multitopping☆ Street Stage",
        theme: "Summer Music Festival",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/smf/smf10.png',
        note: "Cookie Decor for Parfait Cookie",
        color: ["pink", "blue"],
    },
    /*Start of Hollyberry Garden Carnival*/
    {
        name: "Heart Tiles",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc1.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Hollyberry Cookie Statue",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Statue", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc2.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Rose Vine Sofa",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc3.png',
        note: "",
        color: ["green", "gold"],
    },
    {
        name: "Pinkberry Mousse Piano",
        theme: "Hollyberry Garden Carnival",
        size: "6x6",
        points: 32,
        tags: ["Music", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc4.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Blossoming Invitation",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc5.png',
        note: "",
        color: ["white", "pink"],
    },
    {
        name: "Bustling Picnic Table",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 36,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc6.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Glorious Rose Vase",
        theme: "Hollyberry Garden Carnival",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc7.png',
        note: "",
        color: ["cream", "green", "pink"],
    },
    {
        name: "Blueberry Floral Hedge",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc8.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Pinkberry Floral Hedge",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc9.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Pinkberry Arbor",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 36,
        tags: ["Greenery", "Arch"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc10.png',
        note: "",
        color: ["green", "cream"],
    },
    {
        name: "Blueberry Floral Arbor",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 36,
        tags: ["Greenery", "Arch"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc11.png',
        note: "",
        color: ["cream", "green"],
    },
    {
        name: "Gold Choco Marble Bridge",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc12.png',
        note: "",
        color: ["cream", "gold"],
    },
    {
        name: "Milk Choco Marble Railing",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc13.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "Berry Fan Palm",
        theme: "Hollyberry Garden Carnival",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc14.png',
        note: "",
        color: ["cream", "green"],
    },
    {
        name: "Hollyberry Streetlight",
        theme: "Hollyberry Garden Carnival",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc15.png',
        note: "",
        color: ["cream", "brown", "pink"],
    },
    {
        name: "Berry Palm Tree",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Greenery", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc16.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Street Artist Set",
        theme: "Hollyberry Garden Carnival",
        size: "6x6",
        points: 32,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc17.png',
        note: "",
        color: ["cream", "brown"],
    },
    {
        name: "Berries 'n' Goods",
        theme: "Hollyberry Garden Carnival",
        size: "6x6",
        points: 32,
        tags: ["Shop"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc18.png',
        note: "",
        color: ["pink", "green"],
    },
    {
        name: "Candy Cane Candlestick",
        theme: "Hollyberry Garden Carnival",
        size: "2x2",
        points: 20,
        tags: ["Candle"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc19.png',
        note: "",
        color: ["cream", "pink", "gold"],
    },
    {
        name: "Greenish Red Dragon Mascot",
        theme: "Hollyberry Garden Carnival",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc20.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Berry Boat",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 36,
        tags: ["Food", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc21.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Charming Gondola",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 36,
        tags: ["Water", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc22.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Raspberries in a Net",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Food", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc23.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Floating Raspberries",
        theme: "Hollyberry Garden Carnival",
        size: "4x4",
        points: 30,
        tags: ["Food", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc24.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Berry Tea Party",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 400,
        tags: ["Greenery", "Table", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc25.png',
        note: "Cookie Decor for both Princess Cookie and Raspberry Cookie",
        color: ["pink", "green"],
    },
    {
        name: "Hollyberry Pavilion",
        theme: "Hollyberry Garden Carnival",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc26.png',
        note: "Cookie Decor for Hollyberry Cookie",
        color: ["pink", "green"],
    },
    {
        name: "Raspberry Chateau",
        theme: "Hollyberry Garden Carnival",
        size: "16x16",
        points: 440,
        tags: ["Landmark", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/hgc/hgc27.png',
        note: "",
        color: ["pink"],
    },
    /*Start of Welcome to Green Hill*/
    {
        name: "Eggman Gnome",
        theme: "Welcome to Green Hill",
        size: "2x2",
        points: 20,
        tags: ["Gnome", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh1.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Green Hill Matcha Grass",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 0,
        tags: ["Ground", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh2.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Chili Dog Bench",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Food", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh3.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Giant Ring Portal",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 35,
        tags: ["Collab", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh4.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Sonic & Tails Arcade Machine",
        theme: "Welcome to Green Hill",
        size: "6x6",
        points: 32,
        tags: ["Machine", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh5.png',
        note: "",
        color: ["blue", "gold"],
    },
    {
        name: "Mini-Rings",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 30,
        tags: ["Collab", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh6.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Sonic's Treadmill",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 30,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh7.png',
        note: "",
        color: ["blue", "red"],
    },
    {
        name: "Checkered Grass Block",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 30,
        tags: ["Wall", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh8.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Chili Dog Table",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 30,
        tags: ["Table", "Food", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh9.png',
        note: "",
        color: ["red", "brown", "gold"],
    },
    {
        name: "Green Hill Sunflower",
        theme: "Welcome to Green Hill",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh10.png',
        note: "",
        color: ["green", "yellow"],
    },
    {
        name: "Chili Dog Stand",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 30,
        tags: ["Cart", "Food", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh11.png',
        note: "",
        color: ["red", "gold"],
    },
    {
        name: "Green Hill Palm Tree",
        theme: "Welcome to Green Hill",
        size: "4x4",
        points: 40,
        tags: ["Greenery", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh12.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Sonic Photo Zone",
        theme: "Welcome to Green Hill",
        size: "6x6",
        points: 35,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wgh/wgh13.png',
        note: "",
        color: ["blue", "red", "white"],
    },
    /*Start of Abundant Harvest Festival*/
    {
        name: "Quaint Paper Lantern",
        theme: "Abundant Harvest Festival",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Rice Cake Flowerbed",
        theme: "Abundant Harvest Festival",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf2.png',
        note: "",
        color: ["green", "pink", "yellow"],
    },
    {
        name: "Honey-Glazed Rice Cake Bridge",
        theme: "Abundant Harvest Festival",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf3.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Colorful Okchun Tea Set",
        theme: "Abundant Harvest Festival",
        size: "4x4",
        points: 30,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf4.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Sikhye Well",
        theme: "Abundant Harvest Festival",
        size: "6x6",
        points: 32,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Rice Cake Yutnori Board",
        theme: "Abundant Harvest Festival",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf6.png',
        note: "",
        color: ["green", "pink"],
    },
    {
        name: "Autumn Glow Gazebo",
        theme: "Abundant Harvest Festival",
        size: "8x8",
        points: 36,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Rice Cake Basket",
        theme: "Abundant Harvest Festival",
        size: "6x6",
        points: 32,
        tags: ["Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf8.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Moon Mortar Picnic",
        theme: "Abundant Harvest Festival",
        size: "8x8",
        points: 400,
        tags: ["Food", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ahf/ahf9.png',
        note: "Cookie Decor for Moon Rabbit Cookie",
        color: ["white", "brown"],
    },
    /*Start of Mala Tribe's Turf*/
    {
        name: "Volcanic Brownic Tiles",
        theme: "Mala Tribe's Turf",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Volcanic Succulent",
        theme: "Mala Tribe's Turf",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt2.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Legendary Dragon Lamp",
        theme: "Mala Tribe's Turf",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Canele Lava Vent",
        theme: "Mala Tribe's Turf",
        size: "2x2",
        points: 20,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Minecart's Final Step",
        theme: "Mala Tribe's Turf",
        size: "6x6",
        points: 32,
        tags: ["Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Mala Tribe Brazier",
        theme: "Mala Tribe's Turf",
        size: "2x2",
        points: 20,
        tags: ["Fire"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt6.png',
        note: "",
        color: ["gray", "orange"],
    },
    {
        name: "Hot Pot Cauldron",
        theme: "Mala Tribe's Turf",
        size: "6x6",
        points: 32,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt7.png',
        note: "",
        color: ["brown", "gray"],
    },
    {
        name: "Barbecue Signpost",
        theme: "Mala Tribe's Turf",
        size: "2x2",
        points: 20,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt8.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Hot & Spicy Arsenal",
        theme: "Mala Tribe's Turf",
        size: "6x6",
        points: 32,
        tags: ["Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt9.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Hellfire Mala Pond",
        theme: "Mala Tribe's Turf",
        size: "6x6",
        points: 32,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt10.png',
        note: "",
        color: ["brown", "yellow"],
    },
    {
        name: "Boiling Lava Bridge",
        theme: "Mala Tribe's Turf",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt11.png',
        note: "",
        color: ["brown", "gray"],
    },
    {
        name: "Dice Game Table",
        theme: "Mala Tribe's Turf",
        size: "6x6",
        points: 32,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt12.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Chieftain's Tent",
        theme: "Mala Tribe's Turf",
        size: "8x8",
        points: 400,
        tags: ["Tent", "Cookie Decor", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/mtt/mtt13.png',
        note: "Cookie Decor for Mala Sauce Cookie; a second cookie can also interact",
        color: ["red", "brown"],
    },
    /*Start of Sweet & Creepy*/
    {
        name: "Creepy Red Tiles",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc1.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Old Stone Tiles",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc2.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Gothic Fence",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc3.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Halloween Treat Table",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: ["Table", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc4.png',
        note: "",
        color: ["gray", "orange"],
    },
    {
        name: "Fallen Chandelier",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Almost New Onion Rabbit Toy",
        theme: "Sweet & Creepy",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc6.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Pumpkin Lantern Pie",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc7.png',
        note: "",
        color: ["orange"],
    },
    {
        name: "Oddly Familiar Scarecrow",
        theme: "Sweet & Creepy",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc8.png',
        note: "",
        color: ["black", "orange"],
    },
    {
        name: "Old Sugar Tombstone",
        theme: "Sweet & Creepy",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc9.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Readings with Ms. BearJelly",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc10.png',
        note: "",
        color: ["orange"],
    },
    {
        name: "Pumpkin Tree",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc11.png',
        note: "",
        color: ["brown", "orange"],
    },
    {
        name: "Rendezvous with Mr. BearJelly",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc12.png',
        note: "",
        color: ["orange"],
    },
    {
        name: "Ghost Tree",
        theme: "Sweet & Creepy",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc13.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Spooky Old Cinema",
        theme: "Sweet & Creepy",
        size: "8x8",
        points: 80,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc14.png',
        note: "",
        color: ["orange", "black"],
    },
    {
        name: "Pumpkin Parasol Party",
        theme: "Sweet & Creepy",
        size: "6x6",
        points: 400,
        tags: ["Table", "Food", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sc/sc15.png',
        note: "Cookie Decor for Pumpkin Pie Cookie",
        color: ["orange"],
    },
    /*Start of Kingdom's First Jellymart*/
    {
        name: "Too Big Shopping Cart",
        theme: "Kingdom's First Jellymart",
        size: "4x4",
        points: 34,
        tags: ["Cart", "Food", "Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj1.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Long Shopping List",
        theme: "Kingdom's First Jellymart",
        size: "2x2",
        points: 28,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj2.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Jam Shelf",
        theme: "Kingdom's First Jellymart",
        size: "4x4",
        points: 34,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Baked Goods Aisle",
        theme: "Kingdom's First Jellymart",
        size: "4x4",
        points: 34,
        tags: ["Food", "Table"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj4.png',
        note: "",
        color: ["brown", "cream"],
    },
    {
        name: "Cereal Shelf",
        theme: "Kingdom's First Jellymart",
        size: "4x4",
        points: 34,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Ice Cream Fridge",
        theme: "Kingdom's First Jellymart",
        size: "2x2",
        points: 28,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj6.png',
        note: "",
        color: ["blue", "white"],
    },
    {
        name: "World's Kindest Cashier",
        theme: "Kingdom's First Jellymart",
        size: "6x6",
        points: 70,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj7.png',
        note: "",
        color: ["gold", "brown"],
    },
    {
        name: "Fulfilling Shopping Cart",
        theme: "Kingdom's First Jellymart",
        size: "4x4",
        points: 35,
        tags: ["Cart", "Food", "Collab", "Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kfj/kfj8.png',
        note: "Collaboration with e-mart; only available with membership on the e-mart app",
        color: ["brown", "red", "gold"],
    },
    /*Start of Cozy Snowfall Village*/
    {
        name: "Cream Cotton Alpaca",
        theme: "Cozy Snowfall Village",
        size: "4x4",
        points: 30,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv1.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Fresh Snow Angel",
        theme: "Cozy Snowfall Village",
        size: "6x6",
        points: 32,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv2.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Cream Cotton Sheep",
        theme: "Cozy Snowfall Village",
        size: "2x2",
        points: 20,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv3.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Glacial Thorns",
        theme: "Cozy Snowfall Village",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv4.png',
        note: "",
        color: ["blue", "white"],
    },
    {
        name: "Cotton Puff Tree",
        theme: "Cozy Snowfall Village",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv5.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Frosted Snow Bridge",
        theme: "Cozy Snowfall Village",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv6.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Frozen Birch Tree",
        theme: "Cozy Snowfall Village",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv7.png',
        note: "",
        color: ["white", "gray"],
    },
    {
        name: "Snowy Lantern",
        theme: "Cozy Snowfall Village",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv8.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Sugar Glace Berry",
        theme: "Cozy Snowfall Village",
        size: "2x2",
        points: 20,
        tags: ["Greenery", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv9.png',
        note: "",
        color: ["green", "white"],
    },
    {
        name: "Icicle Arch",
        theme: "Cozy Snowfall Village",
        size: "8x8",
        points: 36,
        tags: ["Arch"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv10.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Candy Cane Sledge",
        theme: "Cozy Snowfall Village",
        size: "4x4",
        points: 35,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv11.png',
        note: "",
        color: ["blue", "brown"],
    },
    {
        name: "Cozy Cotton Rug",
        theme: "Cozy Snowfall Village",
        size: "6x6",
        points: 38,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv12.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Ice Fishing Spot",
        theme: "Cozy Snowfall Village",
        size: "8x8",
        points: 40,
        tags: ["Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv13.png',
        note: "",
        color: ["white", "blue"],
    },
    {
        name: "Lantern Tree",
        theme: "Cozy Snowfall Village",
        size: "8x8",
        points: 400,
        tags: ["Greenery", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv16.png',
        note: "Cookie Decor for Sherbet Cookie",
        color: ["white", "green"],
    },
    {
        name: "Snow Blossom Hill",
        theme: "Cozy Snowfall Village",
        size: "8x8",
        points: 400,
        tags: ["Animal", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv14.png',
        note: "Cookie Decor for Cotton Cookie",
        color: ["white", "brown"],
    },
    {
        name: "Timeless Throne of Ice",
        theme: "Cozy Snowfall Village",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/csv/csv15.png',
        note: "Cookie Decor for Frost Queen Cookie",
        color: ["blue", "white"],
    },
    /*Start of Jolly Year-End Festivities*/
    {
        name: "Delivery Gnome",
        theme: "Jolly Year-End Festivities",
        size: "2x2",
        points: 20,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf1.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Fruit Bread Wall",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 30,
        tags: ["Wall"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf2.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Hot Cocoa Vending Machine",
        theme: "Jolly Year-End Festivities",
        size: "2x2",
        points: 20,
        tags: ["Machine", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf3.png',
        note: "",
        color: ["red", "green"],
    },
    {
        name: "Candle of Wishes",
        theme: "Jolly Year-End Festivities",
        size: "2x2",
        points: 20,
        tags: ["Candle"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf4.png',
        note: "",
        color: ["red", "brown"],
    },
    {
        name: "Mint Cocoa Vending Machine",
        theme: "Jolly Year-End Festivities",
        size: "2x2",
        points: 20,
        tags: ["Machine", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf5.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Hot Choco Fountain",
        theme: "Jolly Year-End Festivities",
        size: "8x8",
        points: 36,
        tags: ["Food", "Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf6.png',
        note: "",
        color: ["white", "green", "brown"],
    },
    {
        name: "Season's Greetings Photo Wall",
        theme: "Jolly Year-End Festivities",
        size: "6x6",
        points: 38,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf7.png',
        note: "",
        color: ["red", "white"],
    },
    {
        name: "Holly Cupcake Stand",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 30,
        tags: ["Cart", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf8.png',
        note: "",
        color: ["red", "green"],
    },
    {
        name: "Jingling Churros Arbor",
        theme: "Jolly Year-End Festivities",
        size: "8x8",
        points: 36,
        tags: ["Arch", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf9.png',
        note: "",
        color: ["green", "red", "gold"],
    },
    {
        name: "Holly Streetlight",
        theme: "Jolly Year-End Festivities",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf10.png',
        note: "",
        color: ["red", "brown"],
    },
    {
        name: "Twinkling Snowy Tree",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf11.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Candy Cane Bench",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 25,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf12.png',
        note: "",
        color: ["red", "white"],
    },
    {
        name: "Velvet Sleigh of Presents",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 35,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf13.png',
        note: "",
        color: ["gold", "red"],
    },
    {
        name: "Holiday Candy Table",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 30,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf14.png',
        note: "",
        color: ["red", "white"],
    },
    {
        name: "Pile of Presents",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf15.png',
        note: "",
        color: ["green", "red", "gold"],
    },
    {
        name: "Holly Biscuit Reindeer",
        theme: "Jolly Year-End Festivities",
        size: "4x4",
        points: 30,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf16.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Snowflakes & Cocoa Cafe",
        theme: "Jolly Year-End Festivities",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/jyf/jyf17.png',
        note: "Cookie Decor for Cocoa Cookie; a second cookie can also interact",
        color: ["brown", "red", "white"],
    },
    /*Start of Kingdom of the Unwavering*/
    {
        name: "Simple Stone Tiles",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku1.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Ornate Citadel Tiles",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku2.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Licorice Sea Waterway",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 0,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku3.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Citadel Banner",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: ["Banner"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku4.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Underworld General Idol",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku5.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Modest Table Platform",
        theme: "Kingdom of the Unwavering",
        size: "6x6",
        points: 32,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku6.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Sky General Idol",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku7.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Star Jelly Flower",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku8.png',
        note: "",
        color: ["green", "purple"],
    },
    {
        name: "Cacao Pagoda",
        theme: "Kingdom of the Unwavering",
        size: "6x6",
        points: 38,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku9.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Choco Bamboo",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku10.png',
        note: "",
        color: ["brown", "white"],
    },
    {
        name: "Bridge of Harmony",
        theme: "Kingdom of the Unwavering",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku11.png',
        note: "",
        color: ["gray", "black"],
    },
    {
        name: "Choco Cone Spruce",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku12.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Cacao Tile Wall",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Wall"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku13.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Cacao Tile Gate",
        theme: "Kingdom of the Unwavering",
        size: "8x8",
        points: 40,
        tags: ["Gate"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku14.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Dragon Roar Buk Drum",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku15.png',
        note: "",
        color: ["purple", "black"],
    },
    {
        name: "Folding Screen with a Landscape Painting",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku16.png',
        note: "",
        color: ["purple", "black"],
    },
    {
        name: "Purple Stone Lantern",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku17.png',
        note: "",
        color: ["purple", "black"],
    },
    {
        name: "Dark Cacao Bench",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku18.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Purple Brazier",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: ["Fire"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku19.png',
        note: "",
        color: ["purple", "black"],
    },
    {
        name: "Royal Feast Table",
        theme: "Kingdom of the Unwavering",
        size: "6x6",
        points: 38,
        tags: ["Table", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku20.png',
        note: "",
        color: ["purple", "black"],
    },
    {
        name: "Cacao & Cream Cannon",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku21.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Licorice Jelly Dummy",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku22.png',
        note: "",
        color: ["black", "brown"],
    },
    {
        name: "Kingdom Defender's Weapon Rack",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku23.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Heroic Founder's Statue",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Statue", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku24.png',
        note: "",
        color: ["gray", "white"],
    },
    {
        name: "Licorice Oozeling",
        theme: "Kingdom of the Unwavering",
        size: "6x6",
        points: 32,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku25.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Statue of a Vow",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku26.png',
        note: "",
        color: ["gray", "black"],
    },
    {
        name: "Rice Cake Hound Kennel",
        theme: "Kingdom of the Unwavering",
        size: "2x2",
        points: 20,
        tags: ["Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku27.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Practice Target",
        theme: "Kingdom of the Unwavering",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku28.png',
        note: "",
        color: ["black", "brown"],
    },
    {
        name: "Dark Cacao Stove",
        theme: "Kingdom of the Unwavering",
        size: "6x6",
        points: 32,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku29.png',
        note: "",
        color: ["gray", "brown"],
    },
    {
        name: "Caramel Watchtower",
        theme: "Kingdom of the Unwavering",
        size: "8x8",
        points: 400,
        tags: ["Tower", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku30.png',
        note: "Cookie Decor for Caramel Arrow Cookie",
        color: ["brown", "black"],
    },
    {
        name: "Altar of Bittersweet Rituals",
        theme: "Kingdom of the Unwavering",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku31.png',
        note: "Cookie Decor for Affogato Cookie",
        color: ["purple", "brown"],
    },
    {
        name: "Shelter of Solitude",
        theme: "Kingdom of the Unwavering",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku32.png',
        note: "Cookie Decor for Dark Cacao Cookie",
        color: ["black", "purple"],
    },
    {
        name: "Chocolate Altar of the Fallen",
        theme: "Kingdom of the Unwavering",
        size: "16x16",
        points: 500,
        tags: ["Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/ku/ku33.png',
        note: "",
        color: ["gray", "black"],
    },
    /*Start of Springtime Blossom Picnic Party*/
    {
        name: "Creamy Pink Wafer Fence",
        theme: "Springtime Blossom Picnic Party",
        size: "4x4",
        points: 25,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp1.png',
        note: "",
        color: ["white", "pink"],
    },
    {
        name: "Pink Blossom Streetlight",
        theme: "Springtime Blossom Picnic Party",
        size: "2x2",
        points: 25,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp2.png',
        note: "",
        color: ["pink", "green"],
    },
    {
        name: "Golden Bell Hedge",
        theme: "Springtime Blossom Picnic Party",
        size: "4x4",
        points: 25,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp3.png',
        note: "",
        color: ["yellow"],
    },
    {
        name: "Pink Icing Radio",
        theme: "Springtime Blossom Picnic Party",
        size: "2x2",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp4.png',
        note: "",
        color: ["pink", "white"],
    },
    {
        name: "Pleasant Picnic Basket",
        theme: "Springtime Blossom Picnic Party",
        size: "2x2",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp5.png',
        note: "",
        color: ["brown", "pink"],
    },
    {
        name: "Blooming Cherry Blossom Tree",
        theme: "Springtime Blossom Picnic Party",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp6.png',
        note: "",
        color: ["pink", "brown"],
    },
    {
        name: "Budding Flower Bike",
        theme: "Springtime Blossom Picnic Party",
        size: "4x4",
        points: 45,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp7.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Spring Picnic Cart",
        theme: "Springtime Blossom Picnic Party",
        size: "4x4",
        points: 45,
        tags: ["Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp8.png',
        note: "",
        color: ["white", "pink"],
    },
    {
        name: "Pink Macaron Table Set",
        theme: "Springtime Blossom Picnic Party",
        size: "4x4",
        points: 50,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp9.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Dandelion Trailer",
        theme: "Springtime Blossom Picnic Party",
        size: "6x6",
        points: 50,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp10.png',
        note: "",
        color: ["brown", "white", "pink"],
    },
    {
        name: "Springtime Picnic Mat",
        theme: "Springtime Blossom Picnic Party",
        size: "4x4",
        points: 50,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp11.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Spring Bouquet Truck",
        theme: "Springtime Blossom Picnic Party",
        size: "6x6",
        points: 60,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/sbpp/sbpp12.png',
        note: "",
        color: ["pink", "white"],
    },
    /*Start of First Steps Towards Peace*/
    {
        name: "Crow's Nest Table",
        theme: "First Steps Towards Peace",
        size: "4x4",
        points: 30,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Crow's Nest Sign",
        theme: "First Steps Towards Peace",
        size: "4x4",
        points: 30,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Vanilla Cone Tree",
        theme: "First Steps Towards Peace",
        size: "4x4",
        points: 30,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Crow's Nest Inn",
        theme: "First Steps Towards Peace",
        size: "6x6",
        points: 38,
        tags: ["Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Magic Academy Combo Desk",
        theme: "First Steps Towards Peace",
        size: "4x4",
        points: 35,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp5.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Banner of Eternal Unity",
        theme: "First Steps Towards Peace",
        size: "2x2",
        points: 20,
        tags: ["Banner"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp6.png',
        note: "",
        color: ["white", "gold"],
    },
    {
        name: "Magic Academy Chalkboard",
        theme: "First Steps Towards Peace",
        size: "6x6",
        points: 32,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp7.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Vanilla Orchid Garland Fence",
        theme: "First Steps Towards Peace",
        size: "4x4",
        points: 30,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp8.png',
        note: "",
        color: ["white", "cream"],
    },
    {
        name: "Dark Cacao Tent",
        theme: "First Steps Towards Peace",
        size: "6x6",
        points: 38,
        tags: ["Tent"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp9.png',
        note: "",
        color: ["purple", "black"],
    },
    {
        name: "Council Banquet Table",
        theme: "First Steps Towards Peace",
        size: "6x6",
        points: 38,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp10.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "Snowfield Choco Chip Cairn",
        theme: "First Steps Towards Peace",
        size: "8x8",
        points: 300,
        tags: ["Banner", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp11.png',
        note: "Cookie Decor for Crunchy Chip Cookie",
        color: ["black", "white"],
    },
    {
        name: "Quiet Garden Corner",
        theme: "First Steps Towards Peace",
        size: "8x8",
        points: 400,
        tags: ["Greenery", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/fstp/fstp12.png',
        note: "Cookie Decor for Wildberry Cookie",
        color: ["green", "red", "purple"],
    },
    /*Start of The Republic's Azure Streets*/
    {
        name: "Seashell Tile",
        theme: "The Republic's Azure Streets",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras1.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Dome of the Light",
        theme: "The Republic's Azure Streets",
        size: "8x8",
        points: 40,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras2.png',
        note: "",
        color: ["white", "blue"],
    },
    {
        name: "Luxurious Shell Parasol",
        theme: "The Republic's Azure Streets",
        size: "4x4",
        points: 30,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras3.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Seaside Dining Table",
        theme: "The Republic's Azure Streets",
        size: "4x4",
        points: 35,
        tags: ["Table", "Food", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras4.png',
        note: "",
        color: ["white", "brown"],
    },
    {
        name: "Conch Shell Street Lamp",
        theme: "The Republic's Azure Streets",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras5.png',
        note: "",
        color: ["white", "gold"],
    },
    {
        name: "Jelly Cube Bougainvillea",
        theme: "The Republic's Azure Streets",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras6.png',
        note: "",
        color: ["white", "green"],
    },
    {
        name: "Sandshell Bench",
        theme: "The Republic's Azure Streets",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Gold Azure Banners",
        theme: "The Republic's Azure Streets",
        size: "4x4",
        points: 30,
        tags: ["Banner"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras8.png',
        note: "",
        color: ["gray", "gold", "blue"],
    },
    {
        name: "Creme Seashell Bridge",
        theme: "The Republic's Azure Streets",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras9.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Republic Daily Stand",
        theme: "The Republic's Azure Streets",
        size: "4x4",
        points: 35,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras10.png',
        note: "",
        color: ["brown", "cream"],
    },
    {
        name: "Seashell Fence",
        theme: "The Republic's Azure Streets",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras11.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Olive Skewer Tree",
        theme: "The Republic's Azure Streets",
        size: "2x2",
        points: 20,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras12.png',
        note: "",
        color: ["green", "gray"],
    },
    {
        name: "Azure Ocean Arch",
        theme: "The Republic's Azure Streets",
        size: "8x8",
        points: 36,
        tags: ["Arch"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras13.png',
        note: "",
        color: ["blue", "gray"],
    },
    {
        name: "Ivory Pearl Fountain",
        theme: "The Republic's Azure Streets",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor", "Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras14.png',
        note: "Cookie Decor for Oyster Cookie",
        color: ["gray", "blue"],
    },
    {
        name: "Paladin's Altar",
        theme: "The Republic's Azure Streets",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras15.png',
        note: "Cookie Decor for Financier Cookie",
        color: ["white", "gold"],
    },
    {
        name: "Waterfall of Contemplation",
        theme: "The Republic's Azure Streets",
        size: "12x12",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tras/tras16.png',
        note: "Cookie Decor for Clotted Cream Cookie",
        color: ["white", "gold"],
    },
    /*Start of other*/
    {
        name: "Bear-o'-lantern",
        theme: "Other",
        size: "8x8",
        points: 9,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o1.png',
        note: "Rewarded for Trick or Treat! Bear-O'-Lantern event",
        color: ["orange"],
    },
    {
        name: "Bonus Time Bench",
        theme: "Ovenbreak",
        size: "12x12",
        points: 1,
        tags: ["Collab", "Bench"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o2.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["pink", "brown"],
    },
    {
        name: "Brick Oven Wall",
        theme: "Ovenbreak",
        size: "8x8",
        points: 1,
        tags: ["Collab", "Wall"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o3.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["brown", "orange"],
    },
    {
        name: "Cake Baked from the Heart",
        theme: "Other",
        size: "12x12",
        points: 400,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o4.png',
        note: "Given during Bake the Holiday Cake event",
        color: ["brown"],
    },
    {
        name: "Cookievorous Pet Plant",
        theme: "Other",
        size: "2x2",
        points: 1,
        tags: ["Cookie Interaction", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o5.png',
        note: "Given in the cookie story Herb Cookie's New Plant",
        color: ["green", "red"],
    },
    {
        name: "Dried Mandragonion",
        theme: "Ovenbreak",
        size: "2x2",
        points: 1,
        tags: ["Collab", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o6.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["purple", "green", "brown"],
    },
    {
        name: "Explorer's Hot Air Balloon",
        theme: "Other",
        size: "12x12",
        points: 1,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o7.png',
        note: "Available from Google Play store for 500 Google Play Points",
        color: ["brown", "red", "blue", "yellow", "green"],
    },
    {
        name: "Farseeing Longan Eyes",
        theme: "Ovenbreak",
        size: "4x4",
        points: 30,
        tags: ["Collab", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o8.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["gold"],
    },
    {
        name: "Magic Scroll of Golden Tart",
        theme: "Ovenbreak",
        size: "2x2",
        points: 20,
        tags: ["Collab", "Scroll", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o9.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["gold", "white"],
    },
    {
        name: "Sealing Scroll of Triangular Tart",
        theme: "Ovenbreak",
        size: "2x2",
        points: 20,
        tags: ["Collab", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o10.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["gold", "white"],
    },
    {
        name: "Golden Throne of Ancient Legends",
        theme: "Ovenbreak",
        size: "8x8",
        points: 40,
        tags: ["Collab", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o11.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["gold"],
    },
    {
        name: "Good Boy Cream Wolf",
        theme: "Other",
        size: "4x4",
        points: 300,
        tags: ["Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o12.png',
        note: "Limited time shop exclusive",
        color: ["black", "white"],
    },
    {
        name: "Jelly Conga",
        theme: "Ovenbreak",
        size: "4x4",
        points: 1,
        tags: ["Collab", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o13.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["blue"],
    },
    {
        name: "New Sugar Gnome",
        theme: "Other",
        size: "2x2",
        points: 1,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o14.png',
        note: "Given with coupon codes",
        color: ["brown", "red", "green"],
    },
    {
        name: "Olive Tacks",
        theme: "Ovenbreak",
        size: "4x4",
        points: 1,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o15.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["green"],
    },
    {
        name: "Rice Cake Stand",
        theme: "Other",
        size: "8x8",
        points: 9,
        tags: ["Shop"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o16.png',
        note: "Given during Honey Rice Cakes event",
        color: ["brown", "black"],
    },
    {
        name: "Sausage on a Fork",
        theme: "Ovenbreak",
        size: "2x2",
        points: 1,
        tags: ["Collab", "Food", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o17.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["red"],
    },
    {
        name: "Strange Vials",
        theme: "Ovenbreak",
        size: "4x4",
        points: 1,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o18.png',
        note: "Given during cross-promotion event with Cookie Run: Ovenbreak",
        color: ["pink", "green"],
    },
    {
        name: "Sweet Honey Jar",
        theme: "Other",
        size: "8x8",
        points: 1,
        tags: ["Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o19.png',
        note: "Given during Honey Sweet Honey event",
        color: ["brown", "yellow"],
    },
    {
        name: "Magic Music Box Castle",
        theme: "Other",
        size: "12x12",
        points: 1,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o20.png',
        note: "Given during Pre-Registration Event or from purchasing the Art Book Package",
        color: ["brown", "gold"],
    },
    {
        name: "Pink Valentine Box",
        theme: "Other",
        size: "8x8",
        points: 40,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o21.png',
        note: "Limited time shop exclusive; up to two cookies can interact at once",
        color: ["pink", "red"],
    },
    {
        name: "The Stylish Brothers",
        theme: "Other",
        size: "4x4",
        points: 1,
        tags: ["Statue", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o22.png',
        note: "Collaboration with Ebbets/Musinsa; given with purchase of Ebbets clothes",
        color: ["brown", "cream"],
    },
    {
        name: "Dreamy Picnic with Vinyls",
        theme: "Other",
        size: "4x4",
        points: 30,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o23.png',
        note: "Given with CRK 1st Anniversary OST Bundle",
        color: ["pink", "gold", "red"],
    },
    {
        name: "Star Jelly Tree of Hopes and Dreams",
        theme: "Other",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o24.png',
        note: "Limited time shop exclusive",
        color: ["pink", "purple", "white"],
    },
    {
        name: "Galaxy Z Flip Jelly Shop",
        theme: "Other",
        size: "8x8",
        points: 1,
        tags: ["Landmark", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o25.png',
        note: "Collaboration with Samsung; given with purchase of Samsung Galaxy Z Flip 4",
        color: ["purple", "white"],
    },
    {
        name: "Bigger the Better! Sugar Gnome",
        theme: "Other",
        size: "8x8",
        points: 1,
        tags: ["Collab", "Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o27.png',
        note: "Available from Google Play store",
        color: ["green"],
    },
    {
        name: "Golden Coin from a Strange Land",
        theme: "Other",
        size: "8x8",
        points: 1,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o28.png',
        note: "Available from Google Play store",
        color: ["gold"],
    },
    /*Start of Arena*/
    {
        name: "Greenish Red Dragon Statue",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a1.png',
        note: "reach Master in Brave Season 1",
        color: ["white"],
    },
    {
        name: "Legendary Black Knight",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a2.png',
        note: "reach Master in Brave Season 2",
        color: ["gray"],
    },
    {
        name: "Crimson Dessert Party",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Food", "Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a3.png',
        note: "reach Master in Brave Season 3",
        color: ["red"],
    },
    {
        name: "Eternal Candy Jail",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a4.png',
        note: "reach Master in Pure Vanilla Season 1",
        color: ["brown", "gray"],
    },
    {
        name: "Angelic Clarion Quartet",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a5.png',
        note: "reach Master in Pure Vanilla Season 2",
        color: ["cream"],
    },
    {
        name: "Watchful Vanilla Orchid",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Statue", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a6.png',
        note: "reach Master in Pure Vanilla Season 3",
        color: ["gray"],
    },
    {
        name: "Chest of the Depths",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a7.png',
        note: "reach Master in Sea Fairy Season 1",
        color: ["brown", "gray"],
    },
    {
        name: "Robust Bear Jelly Statue",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Water", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a8.png',
        note: "reach Master in Sea Fairy Season 2",
        color: ["gray", "green"],
    },
    {
        name: "Tidal Equestrian Statue",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Water", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a9.png',
        note: "reach Master in Sea Fairy Season 3",
        color: ["gray", "green"],
    },
    {
        name: "Shield of the Kingdom",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Statue", "Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a10.png',
        note: "reach Master in Hollyberry Season 1",
        color: ["red", "cream"],
    },
    {
        name: "Goblet of the Noble Oath",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a11.png',
        note: "reach Master in Hollyberry Season 2",
        color: ["pink", "cream"],
    },
    {
        name: "Huntress's Wintering Hut",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Cookie Interaction", "Ancient", "Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a12.png',
        note: "reach Master in Hollyberry Season 3",
        color: ["brown", "green", "pink"],
    },
    {
        name: "Blizzard Howler",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Statue", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a13.png',
        note: "reach Master in Frost Queen Season 1",
        color: ["blue"],
    },
    {
        name: "Ice Cream Catapult",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Food", "Weapon"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a14.png',
        note: "reach Master in Frost Queen Season 2",
        color: ["brown"],
    },
    {
        name: "Reflection of the Frost Guardian",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a15.png',
        note: "reach Master in Frost Queen Season 3",
        color: ["blue"],
    },
    {
        name: "Bell of the Twin Dragons",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Ancient", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a16.png',
        note: "reach Master in Dark Cacao Season 1",
        color: ["black", "purple"],
    },
    {
        name: "Twin Dragon Memorial Statue",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Ancient", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a17.png',
        note: "reach Master in Dark Cacao Season 2",
        color: ["black", "gray"],
    },
    {
        name: "Portrait of the Resolute King",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Ancient"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a18.png',
        note: "reach Master in Dark Cacao Season 3",
        color: ["black", "purple"],
    },
    {
        name: "Slumbering Paladin's Sanctuary",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Water", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a19.png',
        note: "reach Master in Radiant Heroes Season 1",
        color: ["cream"],
    },
    {
        name: "Warrior-Goddess of the Ocean",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Water", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a20.png',
        note: "reach Master in Radiant Heroes Season 2",
        color: ["cream"],
    },
    {
        name: "Dawnstrider's Guide",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Water", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a21.png',
        note: "reach Master in Radiant Heroes Season 3",
        color: ["cream"],
    },
    {
        name: "Bottle from the Depths",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a22.png',
        note: "reach Master in Duskgloom Season 1",
        color: ["green", "cream"],
    },
    {
        name: "Oak Barrel of the Sea",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a23.png',
        note: "reach Master in Duskgloom Season 2",
        color: ["cream", "brown"],
    },
    {
        name: "Mythical Tail of Wind and Rain",
        theme: "Arena",
        size: "8x8",
        points: 33,
        tags: ["Water", "Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a24.png',
        note: "reach Master in Duskgloom Season 3",
        color: ["black"],
    },
    /*Start of Kingdom Pass*/
    {
        name: "Every Cookie's Garden House",
        theme: "Kingdom Pass",
        size: "16x16",
        points: 50,
        tags: ["Landmark", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp1.png',
        note: "Brave Season 1",
        color: ["brown", "green"],
    },
    {
        name: "Angel's Fountain",
        theme: "Kingdom Pass",
        size: "16x16",
        points: 400,
        tags: ["Landmark", "Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp2.png',
        note: "Brave Season 2",
        color: ["green", "blue", "white"],
    },
    {
        name: "Big Squishy Visitor",
        theme: "Kingdom Pass",
        size: "12x12",
        points: 400,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp3.png',
        note: "Brave Season 3",
        color: ["yellow"],
    },
    {
        name: "Spring Wisteria Bridge",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Greenery", "Bridge", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp4.png',
        note: "Pure Vanilla Season 1",
        color: ["brown", "purple"],
    },
    {
        name: "Biscuit Playground",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp5.png',
        note: "Pure Vanilla Season 2",
        color: ["brown"],
    },
    {
        name: "Gnominator Statue",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp6.png',
        note: "Pure Vanilla Season 3",
        color: ["pink"],
    },
    {
        name: "Quackity Quack Jelly Boat",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Water", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp7.png',
        note: "Sea Fairy Season 1",
        color: ["yellow"],
    },
    {
        name: "Ship in a Safe Bottle",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp8.png',
        note: "Sea Fairy Season 2",
        color: ["brown", "gold"],
    },
    {
        name: "Romantic Rose Gazebo",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Water", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp9.png',
        note: "Sea Fairy Season 3",
        color: ["white"],
    },
    {
        name: "Sugar Gnome's Pretzel Carriage",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction", "Gnome", "Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp10.png',
        note: "Hollyberry Season 1",
        color: ["brown", "red"],
    },
    {
        name: "Autumn Breeze Camping Site",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp11.png',
        note: "Hollyberry Season 2",
        color: ["brown"],
    },
    {
        name: "Holiday Wish Tree",
        theme: "Kingdom Pass",
        size: "12x12",
        points: 400,
        tags: ["Landmark", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp12.png',
        note: "Hollyberry Season 3",
        color: ["green"],
    },
    {
        name: "Golden Cookie Awards",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp13.png',
        note: "Frost Queen Season 1",
        color: ["gold", "cream"],
    },
    {
        name: "New Year Tiger Statue",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Greenery", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp14.png',
        note: "Frost Queen Season 2",
        color: ["brown", "green", "white"],
    },
    {
        name: "Popcorn Magnolia Swing",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp15.png',
        note: "Frost Queen Season 3",
        color: ["brown", "white"],
    },
    {
        name: "Pink Choco Cherry Tree",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp16.png',
        note: "Dark Cacao Season 1",
        color: ["pink", "brown"],
    },
    {
        name: "Springtime Floral Terrace",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Building", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp17.png',
        note: "Dark Cacao Season 2",
        color: ["pink", "green"],
    },
    {
        name: "Bagel Sandwich Greenhouse",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Building", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp18.png',
        note: "Dark Cacao Season 3",
        color: ["brown"],
    },
    {
        name: "Magic Clockwork Yacht",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp19.png',
        note: "Radiant Heroes Season 1",
        color: ["white", "gold"],
    },
    {
        name: "Rooftop Juice Bar",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp20.png',
        note: "Radiant Heroes Season 2",
        color: ["blue", "green"],
    },
    {
        name: "Bear Jelly Carnival",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp21.png',
        note: "Radiant Heroes Season 3",
        color: ["brown", "pink"],
    },
    {
        name: "Tea Ceremony Under the Full Moon",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp22.png',
        note: "Duskgloom Sea Season 1",
        color: ["brown", "green"],
    },
    {
        name: "House of Sweet Horrors",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp23.png',
        note: "Duskgloom Sea Season 2",
        color: ["gray", "purple"],
    },
    {
        name: "Manager Scarlet's Coffee Truck",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp24.png',
        note: "Duskgloom Sea Season 3",
        color: ["red"],
    },
    /*Start of World of Magic & Dreams*/
    {
        name: "Waterway of Dreams",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 0,
        tags: ["Water", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd1.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Midsummer Tiles of Dreams",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 0,
        tags: ["Ground", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd2.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Mickey's Cheese Tiles",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 0,
        tags: ["Ground", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd3.png',
        note: "",
        color: ["yellow"],
    },
    {
        name: "Mickey's Biscuit Tiles",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 0,
        tags: ["Ground", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd4.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "Wavy Jelly Coral",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Water", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd5.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Fairy Ice Cream Cart",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Cart", "Food", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd6.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Artisan Pie Bench",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Bench", "Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Choco \"Gnome\" of Clubs",
        theme: "World of Magic & Dreams",
        size: "2x2",
        points: 20,
        tags: ["Gnome", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd8.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Strawberry \"Gnome\" of Hearts",
        theme: "World of Magic & Dreams",
        size: "2x2",
        points: 20,
        tags: ["Gnome", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd9.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Painted Wonderland Tree",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Greenery", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd10.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Pink Fence",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Fence", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd11.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Mickey's Brick Wall",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Wall", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd12.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Dreamy Royal Fence",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Fence", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd13.png',
        note: "",
        color: ["blue", "gold"],
    },
    {
        name: "Golden Mickey Streetlight",
        theme: "World of Magic & Dreams",
        size: "2x2",
        points: 20,
        tags: ["Lamp", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd14.png',
        note: "",
        color: ["blue", "gold"],
    },
    {
        name: "Candied Flowerbed",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Greenery", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd15.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Mickey's Garden Tree",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Greenery", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd16.png',
        note: "",
        color: ["green", "brown"],
    },
    {
        name: "Mickey's Bench",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 22,
        tags: ["Bench", "Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd17.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Sugar Gnome Parademaster",
        theme: "World of Magic & Dreams",
        size: "2x2",
        points: 20,
        tags: ["Gnome", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd18.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Mickey's Roadsign",
        theme: "World of Magic & Dreams",
        size: "2x2",
        points: 20,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd19.png',
        note: "",
        color: ["red", "gold"],
    },
    {
        name: "Candy Apple Stand",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 32,
        tags: ["Food", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd20.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Financier Cake Canoe",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 36,
        tags: ["Water", "Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd21.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Kiteseller's Cart",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 32,
        tags: ["Cart", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd22.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Genie's Cotton Candy Cart",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 32,
        tags: ["Cart", "Food", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd23.png',
        note: "",
        color: ["brown", "pink", "blue"],
    },
    {
        name: "Sunday in Never Land",
        theme: "World of Magic & Dreams",
        size: "6x6",
        points: 34,
        tags: ["Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd24.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Mont Blanc Parasol",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 32,
        tags: ["Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd25.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Disney Friends Balloons",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 32,
        tags: ["Cart", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd26.png',
        note: "",
        color: ["blue", "brown"],
    },
    {
        name: "Dreamy Castle Bridge",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd27.png',
        note: "",
        color: ["blue", "brown"],
    },
    {
        name: "Mickey's Billboard",
        theme: "World of Magic & Dreams",
        size: "6x6",
        points: 34,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd28.png',
        note: "",
        color: ["red"],
    },
    {
        name: "Mickey's Fountain",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 36,
        tags: ["Collab", "Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd29.png',
        note: "",
        color: ["blue", "brown"],
    },
    {
        name: "Trainee's Horsey Ride",
        theme: "World of Magic & Dreams",
        size: "4x4",
        points: 32,
        tags: ["Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd30.png',
        note: "",
        color: ["brown", "red"],
    },
    {
        name: "Royal Dressing Room",
        theme: "World of Magic & Dreams",
        size: "6x6",
        points: 34,
        tags: ["Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd31.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Juice Can Spaceship",
        theme: "World of Magic & Dreams",
        size: "6x6",
        points: 34,
        tags: ["Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd32.png',
        note: "",
        color: ["yellow", "green", "red"],
    },
    {
        name: "Magic Mirror of Fate",
        theme: "World of Magic & Dreams",
        size: "6x6",
        points: 140,
        tags: ["Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd33.png',
        note: "",
        color: ["brown", "green"],
    },
    {
        name: "Happily Ever After Photo Zone",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 160,
        tags: ["Cookie Interaction", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd34.png',
        note: "",
        color: ["brown", "blue"],
    },
    {
        name: "Praline Pumpkin Coach",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 160,
        tags: ["Cookie Decor", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd35.png',
        note: "Cookie Decor for Cinderella Cookie",
        color: ["blue", "gold"],
    },
    {
        name: "Little Ocean Globe",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 600,
        tags: ["Cookie Decor", "Disney Crystals", "Water", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd36.png',
        note: "Cookie Decor for Ariel Cookie; produced Wishing Star Crystals during Disney crossover",
        color: ["blue", "purple"],
    },
    {
        name: "Grandmother Willow",
        theme: "World of Magic & Dreams",
        size: "12x12",
        points: 650,
        tags: ["Cookie Decor", "Disney Crystals", "Water", "Greenery", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd37.png',
        note: "Cookie Decor for Pocahontas Cookie; produced Wishing Star Crystals during Disney crossover",
        color: ["green", "brown"],
    },
    {
        name: "Tower of Fireworks",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 600,
        tags: ["Disney Crystals", "Tower", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd38.png',
        note: "produced Wishing Star Crystals during Disney crossover",
        color: ["gray", "blue", "red"],
    },
    {
        name: "Midnight Merry-go-round",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 600,
        tags: ["Disney Crystals", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd39.png',
        note: "produced Wishing Star Crystals during Disney crossover",
        color: ["blue"],
    },
    {
        name: "Ballroom as Old as Time",
        theme: "World of Magic & Dreams",
        size: "16x16",
        points: 700,
        tags: ["Cookie Decor", "Disney Crystals", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd40.png',
        note: "Cookie Decor for Beast Cookie and Belle Cookie; produced Wishing Star Crystals during Disney crossover",
        color: ["gold"],
    },
    {
        name: "Magic Carpet Ride",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 600,
        tags: ["Cookie Interaction", "Disney Crystals", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd41.png',
        note: "produced Wishing Star Crystals during Disney crossover",
        color: ["purple"],
    },
    {
        name: "Golden Cheese Pirate Ship",
        theme: "World of Magic & Dreams",
        size: "12x12",
        points: 650,
        tags: ["Cookie Interaction", "Disney Crystals", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd42.png',
        note: "produced Wishing Star Crystals during Disney crossover",
        color: ["gold", "blue"],
    },
    {
        name: "Stage Aloha",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 600,
        tags: ["Cookie Decor", "Disney Crystals", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd43.png',
        note: "Cookie Decor for Stitch Cookie and Lilo Cookie; produced Wishing Star Crystals during Disney crossover",
        color: ["brown"],
    },
    {
        name: "Carrot Pie House",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 600,
        tags: ["Cookie Decor", "Disney Crystals", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd44.png',
        note: "Cookie Decor for Alice Cookie; produced Wishing Star Crystals during Disney crossover",
        color: ["pink", "brown"],
    },
    {
        name: "Twirly Sky Cupcakes",
        theme: "World of Magic & Dreams",
        size: "16x16",
        points: 700,
        tags: ["Disney Crystals", "Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd45.png',
        note: "produced Wishing Star Crystals during Disney crossover",
        color: ["red", "gold"],
    },
    {
        name: "Disney Ice Cream Truck",
        theme: "World of Magic & Dreams",
        size: "8x8",
        points: 36,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd46.png',
        note: "produced items during Disney Cookies' Wishlist event",
        color: ["brown", "purple"],
    },
    {
        name: "Palace of Dreams",
        theme: "World of Magic & Dreams",
        size: "16x16",
        points: 800,
        tags: ["Collab", "Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wmd/wmd47.png',
        note: "lobby for Disney cookies",
        color: ["brown", "blue"],
    },
    /*Start of Treacherous Duskgloom Sea*/
    {
        name: "Duskgloom Waterway",
        theme: "Treacherous Duskgloom Sea",
        size: "4x4",
        points: 0,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds1.png',
        note: "",
        color: ["blue", "green"],
    },
    {
        name: "Sinking Boat",
        theme: "Treacherous Duskgloom Sea",
        size: "8x8",
        points: 40,
        tags: ["Cookie Interaction", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds2.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Tip of the Rock",
        theme: "Treacherous Duskgloom Sea",
        size: "6x6",
        points: 32,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds3.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Seawater Juice Barrel",
        theme: "Treacherous Duskgloom Sea",
        size: "6x6",
        points: 38,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Floating Wood",
        theme: "Treacherous Duskgloom Sea",
        size: "4x4",
        points: 30,
        tags: ["Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds5.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Salty Shark's Flag",
        theme: "Treacherous Duskgloom Sea",
        size: "4x4",
        points: 30,
        tags: ["Flag"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds6.png',
        note: "",
        color: ["gray", "white"],
    },
    {
        name: "Secure Lantern Brig",
        theme: "Treacherous Duskgloom Sea",
        size: "4x4",
        points: 35,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds7.png',
        note: "",
        color: ["black"],
    },
    {
        name: "Gilded Candy Globe",
        theme: "Treacherous Duskgloom Sea",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds8.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Navigator's Desk",
        theme: "Treacherous Duskgloom Sea",
        size: "4x4",
        points: 30,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds9.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "The Republic's Navy Needs You!",
        theme: "Treacherous Duskgloom Sea",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds10.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Phantom of the Depths",
        theme: "Treacherous Duskgloom Sea",
        size: "16x16",
        points: 1200,
        tags: ["Cookie Decor", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tds/tds11.png',
        note: "Cookie Decor for Black Pearl Cookie",
        color: ["black"],
    },
    /*Start of The Tales of Bangtan Kingdom*/
    {
        name: "Jung Kook Cookie's S'more Timer",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Food", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk1.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "Jung Kook Cookie's S'more Volcano",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk2.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "Jung Kook Cookie's Choco Roll Fence",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Jung Kook Cookie's Plump Marshmallow",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk4.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Jung Kook Cookie's S'more Arch",
        theme: "The Tales of Bangtan Kingdom",
        size: "8x8",
        points: 30,
        tags: ["Collab", "Arch", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk5.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "V Cookie's Sugar Tomato",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk6.png',
        note: "",
        color: ["red"],
    },
    {
        name: "V Cookie's Prince Creme Brulee",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk7.png',
        note: "",
        color: ["gold"],
    },{
        name: "V Cookie's Lunminescent Star Jelly",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk8.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "V Cookie's Jimin Statue",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk9.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "V Cookie's Creme Brulee Fountain",
        theme: "The Tales of Bangtan Kingdom",
        size: "8x8",
        points: 30,
        tags: ["Collab", "Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk10.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Jimin Cookie's Ice Cream Throne",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Interaction", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk11.png',
        note: "",
        color: [""],
    },
    {
        name: "Jimin Cookie's Pure-Hearted Biscuit Fence",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Fence", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk12.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "Jimin Cookie's Cheese Warrior SUGA",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk13.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Jimin Cookie's ARMY's Purest Heart",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk14.png',
        note: "",
        color: [""],
    },
    {
        name: "Jimin Cookie's Marshmallow Gate",
        theme: "The Tales of Bangtan Kingdom",
        size: "8x8",
        points: 30,
        tags: ["Collab", "Gate", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk15.png',
        note: "",
        color: [""],
    },
    {
        name: "j-hope Cookie's Happy Waffle Fence",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Fence", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk16.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "j-hope Cookie's Waffle Monster",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk17.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "j-hope Cookie's Waffle Clovers",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk18.png',
        note: "",
        color: ["orange"],
    },
    {
        name: "j-hope Cookie's Waffle Monster House",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk19.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "j-hope Cookie's Waffle Windmill",
        theme: "The Tales of Bangtan Kingdom",
        size: "6x6",
        points: 25,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk20.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "SUGA Cookie's Black Sesame Screen",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk21.png',
        note: "",
        color: ["black"],
    },
    {
        name: "SUGA Cookie's Hooteok Oak",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Greenery", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk22.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "SUGA Cookie's Macaron Burger",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk23.png',
        note: "",
        color: [""],
    },
    {
        name: "SUGA Cookie's Yakgwa Crown",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk24.png',
        note: "",
        color: ["red"],
    },
    {
        name: "SUGA Cookie's Hangwa Throne",
        theme: "The Tales of Bangtan Kingdom",
        size: "6x6",
        points: 25,
        tags: ["Collab", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk25.png',
        note: "",
        color: ["black", "brown"],
    },
    {
        name: "Jin Cookie's Jelly Worm Bench",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk26.png',
        note: "",
        color: [""],
    },
    {
        name: "Jin Cookie's Frogg-o",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk27.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Jin Cookie's Jelly Worm Fence",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk28.png',
        note: "",
        color: [""],
    },
    {
        name: "Jin Cookie's Jelly Worm Cave Entrance",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk29.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Jin Cookie's Sleeping King Jelly Worm",
        theme: "The Tales of Bangtan Kingdom",
        size: "8x8",
        points: 30,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk30.png',
        note: "",
        color: ["green"],
    },
    {
        name: "RM Cookie's Smiley Bungeo-ppang",
        theme: "The Tales of Bangtan Kingdom",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk31.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "RM Cookie's Bungeo-ppang Truck",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Food", "Cart"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk32.png',
        note: "",
        color: ["cream", "red"],
    },
    {
        name: "RM Cookie's Bungeo-ppang Bench",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Interaction", "Bench", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk33.png',
        note: "",
        color: ["cream"],
    },
    {
        name: "RM Cookie's Red Bean Pine",
        theme: "The Tales of Bangtan Kingdom",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk34.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "RM Cookie's Bungeo-ppang Pond",
        theme: "The Tales of Bangtan Kingdom",
        size: "6x6",
        points: 25,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/tbk/tbk35.png',
        note: "",
        color: ["gray", "blue"],
    },
    /*Start of The Happy Kingdom Life of BTS*/
    {
        name: "Braver Together! Concert Notice Board",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl1.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Purple Checkered Media Backdrop",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Interaction", "Wall"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl2.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Opera Cake Autograph Table",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Table"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl3.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Marshmallow Canvas",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Decor", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl4.png',
        note: "Cookie Decor for Jung Kook Cookie",
        color: ["brown"],
    },
    {
        name: "Sponge Cake Punching Bag",
        theme: "The Happy Kingdom Life of BTS",
        size: "6x6",
        points: 25,
        tags: ["Collab", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl5.png',
        note: "Cookie Decor for Jung Kook Cookie",
        color: ["brown"],
    },
    {
        name: "Golden Candy Cane Saxophone",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Decor", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl6.png',
        note: "Cookie Decor for V Cookie",
        color: ["gold"],
    },
    {
        name: "Choco Fudge Puppy Sofa",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Decor", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl7.png',
        note: "Cookie Decor for V Cookie",
        color: ["brown"],
    },
    {
        name: "Chick Doll Claw Machine",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl8.png',
        note: "Cookie Decor for Jimin Cookie",
        color: ["yellow"],
    },
    {
        name: "Resting Calico Cat Bench",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Decor", "Bench"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl9.png',
        note: "Cookie Decor for Jimin Cookie",
        color: ["brown"],
    },
    {
        name: "S'more Stage of Memories",
        theme: "The Happy Kingdom Life of BTS",
        size: "6x6",
        points: 25,
        tags: ["Collab", "Cookie Decor", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl10.png',
        note: "Cookie Decor for j-hope Cookie",
        color: ["purple"],
    },
    {
        name: "Cookie Kingdom Photo Zone",
        theme: "The Happy Kingdom Life of BTS",
        size: "8x8",
        points: 30,
        tags: ["Collab", "Cookie Decor", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl11.png',
        note: "Cookie Decor for j-hope Cookie",
        color: ["red", "cream"],
    },
    {
        name: "Jelly Set Drum Machine",
        theme: "The Happy Kingdom Life of BTS",
        size: "6x6",
        points: 25,
        tags: ["Collab", "Cookie Decor", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl12.png',
        note: "Cookie Decor for SUGA Cookie",
        color: ["red"],
    },
    {
        name: "Dark Choco Studio Setup",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Decor", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl13.png',
        note: "Cookie Decor for SUGA Cookie",
        color: ["red", "brown"],
    },
    {
        name: "Plump Pumpkin Fishing Boat",
        theme: "The Happy Kingdom Life of BTS",
        size: "8x8",
        points: 30,
        tags: ["Collab", "Cookie Decor", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl14.png',
        note: "Cookie Decor for Jin Cookie",
        color: ["orange"],
    },
    {
        name: "One Big Watermelon",
        theme: "The Happy Kingdom Life of BTS",
        size: "6x6",
        points: 25,
        tags: ["Collab", "Cookie Decor", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl15.png',
        note: "Cookie Decor for Jin Cookie",
        color: ["green"],
    },
    {
        name: "Waffle Bonsai Display Stand",
        theme: "The Happy Kingdom Life of BTS",
        size: "6x6",
        points: 25,
        tags: ["Collab", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl16.png',
        note: "Cookie Decor for RM Cookie",
        color: ["cream", "pink"],
    },
    {
        name: "Buttering Bike",
        theme: "The Happy Kingdom Life of BTS",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl17.png',
        note: "Cookie Decor for RM Cookie",
        color: ["cream"],
    },
    {
        name: "Dreaming Purple Whale Trailer",
        theme: "The Happy Kingdom Life of BTS",
        size: "12x12",
        points: 800,
        tags: ["Collab", "Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/hkl/hkl18.png',
        note: "lobby for BTS cookies",
        color: ["purple"],
    },
    /*Start of We are Purple, We are Together!*/
    {
        name: "Creme Brulee Tiles",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 0,
        tags: ["Collab", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt1.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Twinkling Star Tiles",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 0,
        tags: ["Collab", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt2.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Chocolate Block Asphalt Tile",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 0,
        tags: ["Collab", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt3.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "On-Air Concert Camera",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt4.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "No-Entry Sign Candy",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt5.png',
        note: "",
        color: ["red", "white"],
    },
    {
        name: "Wrapped Choco Guardrail",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Food", "Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt6.png',
        note: "",
        color: ["red", "gray"],
    },
    {
        name: "Butter Roll Floor Light",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt7.png',
        note: "",
        color: ["yellow", "brown"],
    },
    {
        name: "Butter Roll Standing Light",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt8.png',
        note: "",
        color: ["yellow", "brown"],
    },
    {
        name: "Purple Dream-Connecting Arch",
        theme: "We are Purple, We are Together!",
        size: "8x8",
        points: 30,
        tags: ["Collab", "Arch"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt9.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Precious Purple Balloon Bouquet",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt10.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "BTS Balloon Bouquet",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt11.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Planetary Street Light",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt12.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Purple Floor Balloons",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt13.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Fudgy Cream Cactus",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt14.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Neon Pink Flamingo",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Animal"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt15.png',
        note: "",
        color: ["pink"],
    },
    {
        name: "Purple Balloon Refrigerator",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt16.png',
        note: "",
        color: ["purple", "white"],
    },
    {
        name: "Ice Jelly Belt Chair",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt17.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Vintage Upright Piano",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Cookie Interaction", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt18.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Cinnamon Outdoor Stage Fence",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt19.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Basketball Court Straw Fence",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab", "Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt20.png',
        note: "",
        color: ["gray"],
    },
    {
        name: "Jelly Road Cone",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Food"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt21.png',
        note: "",
        color: ["orange"],
    },
    {
        name: "Candy Standing Microphone",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 15,
        tags: ["Collab", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt22.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Donut Open Sign",
        theme: "We are Purple, We are Together!",
        size: "4x4",
        points: 20,
        tags: ["Collab"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt23.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Microphone Table",
        theme: "We are Purple, We are Together!",
        size: "6x6",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor", "Table"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt24.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["gray", "purple"],
    },
    {
        name: "Butter Statue",
        theme: "We are Purple, We are Together!",
        size: "6x6",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor", "Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt25.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["gold"],
    },
    {
        name: "Mikrokosmos Stage",
        theme: "We are Purple, We are Together!",
        size: "8x8",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt26.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["purple"],
    },
    {
        name: "1000ml Milk Carton Truck",
        theme: "We are Purple, We are Together!",
        size: "8x8",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt27.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["cream"],
    },
    {
        name: "Open Outdoor Stage",
        theme: "We are Purple, We are Together!",
        size: "8x8",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt28.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["cream"],
    },
    {
        name: "Milk Cake Discotheque",
        theme: "We are Purple, We are Together!",
        size: "12x12",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt29.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["cream"],
    },
    {
        name: "Boomboom Box Records",
        theme: "We are Purple, We are Together!",
        size: "12x12",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt30.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["cream", "gray"],
    },
    {
        name: "Melting Sweet Ice Cream Truck",
        theme: "We are Purple, We are Together!",
        size: "6x6",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt31.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["cream"],
    },
    {
        name: "Sweet 'n' Pop Donut Shop",
        theme: "We are Purple, We are Together!",
        size: "12x12",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt32.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["gray", "orange", "green"],
    },
    {
        name: "Sunshine Basketball Court",
        theme: "We are Purple, We are Together!",
        size: "8x8",
        points: 600,
        tags: ["Collab", "Army Bombs", "Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt33.png',
        note: "Cookie Decor for BTS Cookies; produced Army Bombs during BTS crossover",
        color: ["green", "cream"],
    },
    {
        name: "Purple Grape Jam Cake Hound",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 40,
        tags: ["Collab", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt34.png',
        note: "Exclusive to BTS' Purple Pass",
        color: ["purple"],
    },
    {
        name: "Fantastic Purple Stage",
        theme: "We are Purple, We are Together!",
        size: "16x16",
        points: 1200,
        tags: ["Collab", "Cookie Decor", "Music"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt35.png',
        note: "Cookie Decor for BTS Cookies; music unlocked upon leveling up and starring BTS cookies; music available until September 2023",
        color: ["purple"],
    },
    {
        name: "Dynamite Cake Hound",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 40,
        tags: ["Collab", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt36.png',
        note: "Rewarded for finishing Dynamite Ticket Book Mission",
        color: ["white", "blue"],
    },
    {
        name: "Butter Cake Hound",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 40,
        tags: ["Collab", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt37.png',
        note: "Rewarded for finishing Butter Ticket Book Mission",
        color: ["brown", "gold"],
    },
    {
        name: "MIC Drop Cake Hound",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 40,
        tags: ["Collab", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt38.png',
        note: "Rewarded for finishing MIC Drop Ticket Book Mission",
        color: ["gray"],
    },
    {
        name: "Permission to Dance Cake Hound",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 40,
        tags: ["Collab", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt39.png',
        note: "Rewarded for finishing Permission to Dance Ticket Book Mission",
        color: ["orange", "purple"],
    },
    {
        name: "Mikrokosmos Cake Hound",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 40,
        tags: ["Collab", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt40.png',
        note: "Rewarded for finishing Mikrokosmos Ticket Book Mission",
        color: ["purple", "pink"],
    },
    {
        name: "Yet To Come Cake Hound",
        theme: "We are Purple, We are Together!",
        size: "2x2",
        points: 40,
        tags: ["Collab", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/wpwt/wpwt41.png',
        note: "Rewarded for finishing Yet To Come Ticket Book Mission",
        color: ["blue"],
    },
    {
        name: "Silent Night Cabin",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp25.png',
        note: "Precious Feeling Season 1",
        color: ["brown", "white"],
    },
    {
        name: "Festive Tree of the Dark",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a25.png',
        note: "reach Master in Precious Feeling Season 1",
        color: ["white"],
    },
    /* Start of Merry Jingle Squirrel Shop */
    {
        name: "Cozy Evergreen Tree",
        theme: "Merry Jingle Squirrel Shop",
        size: "4x4",
        points: 40,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss1.png',
        note: "",
        color: ["green", "white"],
    },
    {
        name: "Tree of Festive Wishes",
        theme: "Merry Jingle Squirrel Shop",
        size: "4x4",
        points: 50,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss2.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Warm Evergreen Tree",
        theme: "Merry Jingle Squirrel Shop",
        size: "4x4",
        points: 40,
        tags: ["Greenery"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss3.png',
        note: "",
        color: ["green", "white"],
    },
    {
        name: "Biscuit Darts Tree",
        theme: "Merry Jingle Squirrel Shop",
        size: "4x4",
        points: 40,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss4.png',
        note: "",
        color: ["green"],
    },
    {
        name: "Winter Snow Sugar Gnome",
        theme: "Merry Jingle Squirrel Shop",
        size: "2x2",
        points: 30,
        tags: ["Gnome"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss5.png',
        note: "",
        color: ["white"],
    },
    {
        name: "Crackling Campfire",
        theme: "Merry Jingle Squirrel Shop",
        size: "4x4",
        points: 40,
        tags: ["Fire"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss6.png',
        note: "",
        color: ["orange", "brown"],
    },
    {
        name: "Mailbox of Joy",
        theme: "Merry Jingle Squirrel Shop",
        size: "2x2",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss7.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Cozy Knitted Goods Shop",
        theme: "Merry Jingle Squirrel Shop",
        size: "4x4",
        points: 50,
        tags: ["Shop"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss8.png',
        note: "",
        color: ["brown", "red", "white"],
    },
    {
        name: "Holiday Roll Cake Table",
        theme: "Merry Jingle Squirrel Shop",
        size: "4x4",
        points: 50,
        tags: ["Table", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss9.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Jolly Holiday Shop",
        theme: "Merry Jingle Squirrel Shop",
        size: "6x6",
        points: 80,
        tags: ["Shop", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/mjss/mjss10.png',
        note: "",
        color: ["brown", "white", "green"],
    },
    {
        name: "Master Black Rabbit's Fortune-telling Parlor",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp26.png',
        note: "Precious Feeling Season 2",
        color: ["brown", "black", "orange"],
    },
    {
        name: "Hidden Away Relics",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a26.png',
        note: "reach Master in Precious Feeling Season 2",
        color: ["cream"],
    },
    {
        name: "Eternal Hero Memorial",
        theme: "Other",
        size: "12x12",
        points: 440,
        tags: ["Landmark"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/other/o1.png',
        note: "Available as reward for completing the Might of the Ancients event",
        color: ["cream", "white"],
    },
    {
        name: "Snow Crystal Palm Tree",
        theme: "Kingdom Pass",
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Greenery", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp27.png',
        note: "Precious Feeling Season 3",
        color: ["blue", "white"],
    },
    {
        name: "Loyal Friend's Shelter",
        theme: "Arena",
        size: "6x6",
        points: 33,
        tags: ["Animal", "Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a27.png',
        note: "reach Master in Precious Feeling 3; last season to have unique arena decor :(",
        color: ["black"],
    },
    /*Start of 2nd Anniversary*/
    {
        name: "Anniversary Hat Cake Hound",
        theme: "2nd Anniversary",
        size: "2x2",
        points: 30,
        tags: ["Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/2a/2a1.png',
        note: "Limited time shop exclusive",
        color: ["cream", "white"],
    },
    {
        name: "Giant Anniversary Cake Hound",
        theme: "2nd Anniversary",
        size: "4x4",
        points: 40,
        tags: ["Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/2a/2a2.png',
        note: "Limited time shop exclusive; reward for Cake Hound Frenzy event",
        color: ["cream", "white", "blue"],
    },
    {
        name: "Anniversary Cake Hound Tower",
        theme: "2nd Anniversary",
        size: "4x4",
        points: 40,
        tags: ["Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/2a/2a3.png',
        note: "Limited time shop exclusive; reward for Cake Hound Frenzy event",
        color: ["cream", "white"],
    },
    {
        name: "Anniversary Party Cake",
        theme: "2nd Anniversary",
        size: "4x4",
        points: 40,
        tags: ["Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/2a/2a4.png',
        note: "Limited time shop exclusive; reward for Cake Hound Frenzy event",
        color: ["cream", "white"],
    },
    {
        name: "The Shy Swan's Proposal",
        theme: "Other",
        size: "8x8",
        points: 40,
        tags: ["Water", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/other/o26.png',
        note: "Limited time shop exclusive",
        color: ["red", "white"],
    },
    {
        name: "Blue Crystal Crescent",
        theme: "Kingdom Pass", 
        size: "8x8",
        points: 400,
        tags: ["Landmark", "Water", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp28.png',
        note: "Moonlight Season 1",
        color: ["blue"],
    },
    /*Start of Starry Dream Station*/
    {
        name: "Railroad of Endless Dreams(Curved Track 4)",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Train", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds1.png',
        note: "Use with the Dream Train decors",
        color: ["purple", "blue"],
    },
    {
        name: "Railroad of Endless Dreams(Curved Track 3)",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Train", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds2.png',
        note: "Use with the Dream Train decors",
        color: ["purple", "blue"],
    },
    {
        name: "Railroad of Endless Dreams(Curved Track 2)",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Train", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds3.png',
        note: "Use with the Dream Train decors",
        color: ["purple", "blue"],
    },
    {
        name: "Railroad of Endless Dreams(Curved Track 1)",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Train", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds4.png',
        note: "Use with the Dream Train decors",
        color: ["purple", "blue"],
    },
    {
        name: "Railroad of Endless Dreams(Straight Track 2)",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Train", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds5.png',
        note: "Use with the Dream Train decors",
        color: ["purple", "blue"],
    },
    {
        name: "Railroad of Endless Dreams(Straight Track 1)",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Train", "Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds6.png',
        note: "Use with the Dream Train decors",
        color: ["purple", "blue"],
    },
    {
        name: "Peculiar Dream Matter",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds7.png',
        note: "",
        color: ["purple"],
    },
    {
        name: "Morning Star Tiles",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds8.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Constellation Tiles",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 0,
        tags: ["Ground"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds9.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Blue Bubble Astro Binoculars",
        theme: "Starry Dream Station",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds10.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Soda Star Jelly",
        theme: "Starry Dream Station",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds11.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Moon and Wisdom Bridge",
        theme: "Starry Dream Station",
        size: "8x8",
        points: 36,
        tags: ["Bridge", "Water"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds12.png',
        note: "",
        color: ["blue", "gold"],
    },
    {
        name: "Someone's Magic Summoning Circle",
        theme: "Starry Dream Station",
        size: "6x6",
        points: 38,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds13.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Retired Reminiscing Star",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds14.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Dreamy Drifting Star",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds15.png',
        note: "",
        color: ["gold"],
    },
    {
        name: "Shattered Stone Bust",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: ["Statue"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds16.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Nightsky Camping Chair",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: ["Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds17.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Dream Traveler's Hourglass",
        theme: "Starry Dream Station",
        size: "2x2",
        points: 25,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds18.png',
        note: "",
        color: ["blue", "gold"],
    },
    {
        name: "Starlight Candy Street Lamp",
        theme: "Starry Dream Station",
        size: "2x2",
        points: 20,
        tags: ["Lamp"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds19.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Dreamy Fence",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: ["Fence"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds20.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Travel Bag of Thrill",
        theme: "Starry Dream Station",
        size: "2x2",
        points: 20,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds21.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Blinking Dream Traffic Light",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds22.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Ticktock Dream Train Schedule",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: [],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds23.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "The Daily Dream Shop",
        theme: "Starry Dream Station",
        size: "6x6",
        points: 32,
        tags: ["Shop"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds24.png',
        note: "",
        color: ["brown", "blue"],
    },
    {
        name: "Starry Cloud Ticket Booth",
        theme: "Starry Dream Station",
        size: "6x6",
        points: 38,
        tags: ["Building"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds25.png',
        note: "",
        color: ["brown"],
    },
    {
        name: "Dreamy Bench",
        theme: "Starry Dream Station",
        size: "4x4",
        points: 30,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds26.png',
        note: "",
        color: ["blue"],
    },
    {
        name: "Sleepyhead Bench",
        theme: "Starry Dream Station",
        size: "6x6",
        points: 38,
        tags: ["Bench", "Cookie Interaction"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds27.png',
        note: "",
        color: ["blue", "brown"],
    },
    {
        name: "Sanctuary of Faded Stars",
        theme: "Starry Dream Station",
        size: "8x8",
        points: 400,
        tags: ["Cookie Decor"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds28.png',
        note: "Cookie Decor for Stardust Cookie; ",
        color: ["gold", "gray"],
    },
    {
        name: "Moon and Star Clock Tower",
        theme: "Starry Dream Station",
        size: "12x12",
        points: 1200,
        tags: ["Cookie Decor", "Tower"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/sds/sds29.png',
        note: "Cookie Decor for Moonlight Cookie",
        color: ["blue"],
    },
    /*Start of City of Wizards*/
    {
        name: "Dream Train Aurora Engine Room",
        theme: "Starry Dream Station",
        size: "6x6",
        points: 400,
        tags: ["Train", "Landmark", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow1.png',
        note: "Exclusive to Moonlight pass; produced Moonlight Shards during Moonlight Cookie banner",
        color: ["blue", "gold"],
    },
    {
        name: "Dream Train Aurora Standard Car",
        theme: "Starry Dream Station",
        size: "6x6",
        points: 38,
        tags: ["Train", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow2.png',
        note: "Exclusive to Moonlight Pass, Moonlight Shards event and Crunchy Dreams event",
        color: ["blue", "gold"],
    },
    {
        name: "Cosmic Fountain",
        theme: "City of Wizards",
        size: "8x8",
        points: 440,
        tags: ["Landmark", "Fountain"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow3.png',
        note: "Reward for completeing Crunchy Dreams event",
        color: ["blue"],
    },
    {
        name: "Doom Star X-1 Protection Unit",
        theme: "City of Wizards",
        size: "8x8",
        points: 440,
        tags: ["Landmark", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow4.png',
        note: "Limited time shop exclusive",
        color: ["gold"],
    },
    {
        name: "Infinity Donut Spaceship",
        theme: "City of Wizards",
        size: "4x4",
        points: 35,
        tags: ["Floating", "Cake Hound"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow5.png',
        note: "Limited time shop exclusive",
        color: ["cream", "pink"],
    },
    {
        name: "Howling Doughnut Vortex",
        theme: "City of Wizards",
        size: "12x12",
        points: 440,
        tags: ["Landmark", "Cookie Interaction", "Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow6.png',
        note: "Produced Comet Candies during Stardust banner; exclusive to Starlight pass",
        color: ["black", "red"],
    },
    {
        name: "Hard Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow7.png',
        note: "exclusive to Starlight pass",
        color: ["purple"],
    },
    {
        name: "Bear Jelly Planet",
        theme: "City of Wizards",
        size: "4x4",
        points: 35,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow8.png',
        note: "exclusive to Starlight pass",
        color: ["pink", "green"],
    },
    {
        name: "Refreshing Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow9.png',
        note: "exclusive to Starlight pass",
        color: ["blue"],
    },
    {
        name: "Glittering Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow10.png',
        note: "exclusive to Starlight pass",
        color: ["red"],
    },
    {
        name: "Mint Pistachio Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow11.png',
        note: "exclusive to Starlight pass",
        color: ["blue", "green"],
    },
    {
        name: "Lemon Berry Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow12.png',
        note: "exclusive to Starlight pass",
        color: ["orange", "pink"],
    },
    {
        name: "Cheese Cat Planet",
        theme: "City of Wizards",
        size: "4x4",
        points: 35,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow13.png',
        note: "exclusive to Starlight pass",
        color: ["blue", "orange"],
    },
    {
        name: "Sleek Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow14.png',
        note: "Reward for completing Traveler of the Universe missions",
        color: ["green"],
    },
    {
        name: "Delicate Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow15.png',
        note: "Reward for completing Traveler of the Universe missions",
        color: ["pink"],
    },
    {
        name: "Cheerful Candy Planet",
        theme: "City of Wizards",
        size: "2x2",
        points: 25,
        tags: ["Floating"],
        url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/cow/cow16.png',
        note: "Reward for completing Traveler of the Universe missions",
        color: ["orange"],
    },
    // {
    //     name: "Cozy Hug of Spring",
    //     theme: "Kingdom Pass",
    //     size: "8x8",
    //     points: 400,
    //     tags: ["Landmark", "Cookie Interaction"],
    //     url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp29.png',
    //     note: "Moonlight Season 2",
    //     color: ["pink"],
    // },
];

// {
//     name: "",
//     theme: "The Tales of Bangtan Kingdom",
//     size: "",
//     points: ,
//     tags: ["Collab"],
//     url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/regular_decor/tbk/tbk.png',
//     note: "",
//     color: [""],
// },

// update format
// {
//     name: "",
//     theme: "Kingdom Pass",
//     size: "",
//     points: ,
//     tags: ["Landmark", "Building"],
//     url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/kp/kp.png',
//     note: "",
//     color: [""],
// },
// {
//     name: "",
//     theme: "Arena",
//     size: "",
//     points: ,
//     tags: [""],
//     url: 'https://cdn.jsdelivr.net/gh/SamuelLin213/crk_db_assets@main/limited_decor/arena/a.png',
//     note: "reach Master in ",
//     color: [""],
// },

const themeArray = [...new Set(decorArray.flatMap(({theme}) => theme))].sort();

const sizeArray = [
    "2x2",
    "3x3",
    "4x4",
    "6x6",
    "8x8",
    "12x12",
    "16x16"
];

const colorArray = [...new Set(decorArray.flatMap(({color}) => color))].sort().filter(colorFilter);
function colorFilter(color)
{
    if(/^[A-Za-z]*$/.test(color) && color)
    {
        return true;
    }
    else{
        return false;
    }
}

const tagsArray = [...new Set(decorArray.flatMap(({tags}) => tags))].sort();

export {decorArray, themeArray, sizeArray, tagsArray, colorArray};
